import * as _ from 'underscore';
import * as $ from 'jquery';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { TransactionModel } from '../../../platform/tsx/dataEdit/TransactionModel';
import * as DateTimeFunctions from '../../../platform/ts/DateTimeFunctions';
import { convertIntervalValueToAttrQueryParam } from '../../..//platform/tsx/IntervalsSelect';
import { explainAttributeType, JsonTraverse } from '../../../platform/ts/Utilities';

import { IIntervals, AQL } from '../../../platform/ts/AqlUtility';

import { ATTRIBUTE_TYPES, ATTRIBUTE_CONTROL_TYPES, TIME_PART_TYPES } from '../../../platform/ts/ConfigurationConstants';

import {
    RELATIONS,
    URL_KEYS,
    VARIABLE_FISCAL_MONTH,
    VARIABLE_NULL,
    VARIABLE_PERIOD_END,
    VARIABLE_PERIOD_START,
    VARIABLE_USER_ID
} from '../../../platform/tsx/filtering/Constants';

import {
    IQueryFilter,
    IGlobalAttributeFilter,
    IGlobalAttributeFilters,
    IGlobalAttributeFilterCollection,
    IAQLFilter,
    IAttributeOptions,
    FilterType,
    IPeriodFilter,
    IGlobalFilterControl,
    AttributeValueShowingType,
    IAttributeName,
    IDataQueryData,
    IGlobalStateFilters,
    IScopeOptions,
    IExchangeObjectRecord,
    IAttrQueryFilterFieldValue,
    INewAttributeFilterColections
} from '../../../platform/tsx/filtering/Interfaces';

import {
    EntityModelsStore,
    ATTRIBUTE_SEPARATOR,
    IExpression,
    IGetValuesResult,
    getExpressionType
} from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';

import {
    sameAttributes,
    isFiscalTimePart,
    useApplyButton,
    getApplyMode,
    ApplyModes,
    getApplySwitcherState,
    ApplySwitcherStates,
    variableNamesAreEqual,
    normalizeVariableName,
    hasConstantValueType,
    getVariableType,
    findVariables,
    getAttributesForTree,
    relationDoesNotAllowToHaveValue,
    logicalExpressionIsOff,
    isIsSubnodeOfRelation,
    getValueType,
    isValueEmpty,
    formatValueByType,
    parseURLAttribute,
    convertControlTypeToAttributeType,
    convertAttributeTypeToControlType,
    checkVariableType,
    findFirstVariable,
    encodeParameterForURL,
    encodeParameterValueForURL,
    decodeParameterValueForURL,
    dropTemporaryAttributeFilters,
    mergeAttributeFilterCollections,
    createAttributeID,
    dropNotNeededTimeParts,
    checkGlobalFilterControlAttributes
} from '../../../platform/tsx/filtering/FilterUtilities';

import { getCultureValues, ICultureValues } from '../../../../_common/platform/ts/Globalization';

import { IValuesCollection } from '../../../platform/ts/appTheme';
import { IDisplayValue } from '../../../platform/ts/Interfaces';

import { IURLQuery, IURLQueryValue } from '../../../../pdc-platform/src/ts/Interfaces';

import { getDataQueryData, getDataQueryDataForTree } from '../../tsx/filtering/AttributeFiltersCreator';

export interface IGlobalStateState extends IGlobalStateFilters {
    notAppliedFilters?: IGlobalStateFilters;
}

export default class GlobalState {
    private _glob: IGlob;
    private _workspace: number;
    private _tab: number;
    private _mainTab: number;
    private _namespace: string;
    private _state: IGlobalStateState;
    private _exchangeObject: IExchangeObjectRecord[];
    private _applyButtonWasPressed: boolean;

    private _attributeFilterWidgets: {
        [filterID: string]: {
            deferred: JQueryDeferred<INewAttributeFilterColections>;
            inProcess?: boolean;
        };
    };

    private _periodFilterWidgets: { [filterID: string]: boolean };
    private _toolbarFilterWidget: number;
    private _deferreds: JQueryDeferred<any>[];

    public transactionModel: TransactionModel;

    constructor(
        glob: IGlob,
        workspace: number,
        tab: number,
        namespaceName: string,
        state: IGlobalStateState,
        mainTab: number
    ) {
        this._glob = glob;
        this._workspace = workspace;
        this._tab = tab;
        this._namespace = namespaceName;
        this._mainTab = mainTab;
        this._attributeFilterWidgets = {};
        this._periodFilterWidgets = {};
        this._toolbarFilterWidget = null;
        this._state = this.cleanNonExistingDataSources(state);
        this._exchangeObject = [];
        this._applyButtonWasPressed = false;
        this._deferreds = [];

        this.transactionModel = new TransactionModel(glob);
    }

    public get tabID() {
        return this._tab;
    }

    public get workspaceID() {
        return this._workspace;
    }

    public get applyButtonWasPressed() {
        return this._applyButtonWasPressed;
    }

    public set applyButtonWasPressed(value: boolean) {
        this._applyButtonWasPressed = value;
    }

    public static createFactory(
        glob: IGlob,
        workspaceID: number,
        tabID: number,
        namespaceName?: string,
        state?: IGlobalStateState,
        mainTab?: number
    ): GlobalState {
        if (workspaceID == null) {
            throw 'Fail to create Global State. workspaceID is undefined.';
        }

        let result: GlobalState;

        if (glob.GlobalStates == null) {
            glob.GlobalStates = [];
        } else {
            result = glob.GlobalStates.find(
                (globalState) => globalState.tabID === tabID && globalState.workspaceID === workspaceID
            );
        }

        if (result == null) {
            result = new GlobalState(glob, workspaceID, tabID, namespaceName, state, mainTab);
            glob.GlobalStates.push(result);
        }

        return result;
    }

    public static getGlobalState(glob: IGlob, tabID: number): GlobalState {
        if (glob.GlobalStates != null) {
            return glob.GlobalStates.find((globalState) => globalState.tabID === tabID);
        }

        return null;
    }

    public setState(state) {
        this._state = state;
    }

    private _lastEventCallTime: number = null;
    private _delayedSetStateEvent: NodeJS.Timer;

    private cleanNonExistingDataSources(state: IGlobalStateState) {
        const stateCopy = $.extend(true, {}, state);
        const dsList = this._glob.EntityModelsStore.getDataSources();

        //EVG Datasources can be not loaded here when making filters from URL.
        if (dsList.length > 0 && stateCopy.attributeFilters != null) {
            const keys = _.keys(stateCopy.attributeFilters);

            for (let i = 0; i < keys.length; i++) {
                if (
                    !_.find(dsList, (ds) => {
                        return ds.dataSourceID === parseInt(keys[i]);
                    })
                ) {
                    delete stateCopy.attributeFilters[keys[i]];
                }
            }
        }

        //EVG 14.11.23: For backward compartibility with old Widget Links.
        const rangeSelector = stateCopy['rangeSelector'];

        if (rangeSelector != null) {
            stateCopy.periodFilters = [rangeSelector];
            delete stateCopy['rangeSelector'];
        }

        return stateCopy;
    }

    public getExchangeObject() {
        return this._exchangeObject;
    }

    public putDataToExchangeObject(records: IExchangeObjectRecord[], runTimeWidgetID: number) {
        if (compareObjects(records, this._exchangeObject)) {
            return;
        }

        let changed = false;

        records.forEach((record) => {
            const existingRecord = this._exchangeObject.find((storedRecord) => {
                return (
                    storedRecord.widgetID === record.widgetID &&
                    storedRecord.exchangeObjectName === record.exchangeObjectName &&
                    sameAttributes(storedRecord, record)
                );
            });

            if (existingRecord != null) {
                // OE: See issue #67786, Message #522642
                // record.values.forEach((value) => {
                //     if (
                //         existingRecord.values.find((existingValue) => {
                //             return existingValue === value;
                //         }) == null
                //     ) {
                //         existingRecord.values.push(value);
                //     }
                // });
                if (!changed) {
                    if (!compareObjects(existingRecord.values, record.values)) {
                        changed = true;
                    }
                }

                if (changed) {
                    existingRecord.values = [...record.values];
                }
            } else {
                this._exchangeObject.push({ ...record });
                changed = true;
            }
        });

        if (changed) {
            this._glob.AppActions.workspaceBufferedDataChanged(this._workspace, this._tab, runTimeWidgetID);
        }
    }

    public cleanDataInExchangeObject(widgetID: number) {
        this._exchangeObject = this._exchangeObject.filter((record) => record.widgetID !== widgetID);
    }

    // delayInterval > 0 - set filter after timeout.
    // delayInterval = 0 - set filter immediatelly.
    // delayInterval < 0 - set filter, but do not rise event.
    public riseWorkspaceSetStateEvent(delayInterval: number) {
        if (this._delayedSetStateEvent != null) {
            clearTimeout(this._delayedSetStateEvent);
            this._delayedSetStateEvent = null;
        }

        if (delayInterval < 0) {
            return;
        } else if (delayInterval == null) {
            delayInterval = 500;
        }

        if (this._lastEventCallTime != null) {
            const minDelayInterval = new Date().getTime() - this._lastEventCallTime - 200;

            if (minDelayInterval < delayInterval) {
                delayInterval = minDelayInterval;
            }
        }

        if (delayInterval > 0) {
            this._delayedSetStateEvent = setTimeout(() => {
                this.riseWorkspaceSetStateEvent(0);
            }, delayInterval);
        } else {
            this._lastEventCallTime = new Date().getTime();

            // Always rize event on the same tab.
            this._glob.AppActions.workspaceSetState(this._workspace, this._tab, this._namespace, this._state);

            // In case of tabbed Attribute filter we need to rize event on workspace tab also.
            if (this._tab < 0) {
                this._glob.AppActions.workspaceSetState(this._workspace, this._mainTab, this._namespace, this._state);
            }
        }
    }

    public getAttributeFilterCollection(): IGlobalAttributeFilterCollection {
        return this._state != null ? this._state.attributeFilters : null;
    }

    public getAttributeFilters(
        dataSourceID: number,
        scopeOptions: IScopeOptions,
        attributeFilterCollection?: IGlobalAttributeFilterCollection,
        addDrillDownFilters?: boolean
    ): IGlobalAttributeFilters {
        if (dataSourceID == null) {
            return null;
        }

        if (attributeFilterCollection == null) {
            attributeFilterCollection = this.getAttributeFilterCollection();
        }

        let result: IGlobalAttributeFilters = null;

        if (attributeFilterCollection != null) {
            const filters = attributeFilterCollection[dataSourceID.toString()];

            if (!_.isEmpty(filters)) {
                result = {};

                _.each(filters, (filter, attributeID) => {
                    if (this.scopeCheck(filter.scopeOptions, scopeOptions)) {
                        result[attributeID] = filter;
                    }
                });
            }
        }

        if (addDrillDownFilters) {
            result = this.makeDrillDownFilters(scopeOptions, dataSourceID, result);
        }

        return result;
    }

    public scopeCheck(filterScope: IScopeOptions, containerScope: IScopeOptions) {
        if (filterScope == null) {
            return true; //Default Scope.
        }

        const filterScopeID = filterScope.scopeID;

        if (filterScopeID == null) {
            return true; //Default or the same Scope.
        }

        if (containerScope != null) {
            if (filterScopeID === containerScope.scopeID) {
                return true; //Default or the same Scope.
            }

            if (containerScope.parentScopes != null) {
                return containerScope.parentScopes.indexOf(filterScopeID) >= 0;
            }
        }

        return false;
    }

    private setGlobalFilterControlToPeriodFilter(filter: IAQLFilter, globalFilterControl: IGlobalFilterControl) {
        if (globalFilterControl != null) {
            const { periodFilter } = globalFilterControl;

            if (periodFilter != null && periodFilter.attributes != null) {
                if (periodFilter.attributes.length === 0) {
                    // No Period Filtering when Default Periof Filtering is off, but no Period Attribute is specified.
                    return false;
                }

                const filters = _.map(periodFilter.attributes, (filter) => {
                    const attributeName = filter.attribute || filter['name']; //EVG 16.02.2021 'name' is an obsolete format.

                    return {
                        attrib: attributeName.split(ATTRIBUTE_SEPARATOR),
                        periodType: filter.periodType
                    };
                });

                filter.periodFilterControl = filters;
            }
        }

        return true;
    }

    // VR: get collection of Timeparts of PeriodFilter object like {"year": 2001, "week": [2,3]}; returns TRUE if exist at least one item.
    private getTimeParts(filter: IPeriodFilter): IAQLFilter {
        let result: IAQLFilter;

        _.each(TIME_PART_TYPES, (timePart) => {
            const value = filter[timePart];

            if (value != null && !_.isEqual(value, [])) {
                const { timePeriodStartMonth } = filter;

                if (result == null) {
                    result = {};
                }

                if (timePeriodStartMonth != null && isFiscalTimePart(timePart)) {
                    result.timePeriodStartMonth =
                        timePeriodStartMonth === -1 ? filter.variables.fiscalMonth : timePeriodStartMonth;
                    result[timePart.toLowerCase()] = value; // todo: Because backend accept 'halfyearfiscal' instead 'halfYearFiscal', must be re-done by Alex!
                    // see WorkItem [102524]: Backend accepts "fiscalyear" instead "fiscalYear" in filter Timepart = BUG
                } else {
                    result[timePart] = value;
                }
            }
        });

        return result;
    }

    public getPeriodFilters(): IPeriodFilter[] {
        if (this._state == null || this._state.periodFilters == null) {
            return null;
        }

        return [...this._state.periodFilters];
    }

    public getPeriodFilter(scopeOptions: IScopeOptions, periodFilters?: IPeriodFilter[]): IPeriodFilter {
        if (periodFilters == null) {
            if (this._state == null || this._state.periodFilters == null) {
                return null;
            }

            periodFilters = this._state.periodFilters;
        }

        if (periodFilters == null) {
            return null;
        }

        let result: IPeriodFilter;

        if (scopeOptions != null) {
            result = periodFilters.find((filter) => {
                return this.scopeCheck(filter.scopeOptions, scopeOptions);
            });
        }

        if (result == null) {
            // Get default Period Filter.
            result = periodFilters.find((filter) => filter.scopeOptions == null);
        }

        if (result == null && scopeOptions != null && periodFilters.length > 0 && _.isEmpty(scopeOptions)) {
            // It is for the cases when there is no default Period Filter and scopeOptions cannot be specified.
            // In this case the first found Period Filter is used. It can be wrong in some use cases.
            result = periodFilters[0];
        }

        return result;
    }

    private makePeriodFilter(
        result: IAQLFilter[],
        scopeOptions: IScopeOptions,
        globalFilterControl: IGlobalFilterControl,
        periodFilter?: IPeriodFilter
    ): void {
        if (periodFilter === undefined) {
            periodFilter = this.getPeriodFilter(scopeOptions);
        }

        if (periodFilter == null) {
            return;
        }

        if (!this.scopeCheck(periodFilter.scopeOptions, scopeOptions)) {
            return;
        }

        periodFilter = dropNotNeededTimeParts(periodFilter);

        const timeParts = this.getTimeParts(periodFilter);
        const { from, to } = periodFilter;

        if (from != null || to != null || timeParts != null) {
            let aqlFilter: IAQLFilter = {
                type: AQL.TYPE_PERIOD
            };

            if (this.setGlobalFilterControlToPeriodFilter(aqlFilter, globalFilterControl)) {
                if (from != null) {
                    aqlFilter.from = from;
                }

                if (to != null) {
                    aqlFilter.to = to;
                }

                if (timeParts != null) {
                    aqlFilter = { ...aqlFilter, ...timeParts };
                }

                result.push(aqlFilter);
            }
        }
    }

    public dropPeriodFilter() {
        if (this._state != null) {
            this._state.periodFilters = null;
        }
    }

    public dropAttributeFilter() {
        if (this._state != null) {
            this._state.attributeFilters = null;
        }
    }

    public notAppliedFiltersExist() {
        return this._state != null && this._state.notAppliedFilters != null;
    }

    public dropNotAppliedFilters() {
        if (this._state != null) {
            this._state.notAppliedFilters = null;
        }
    }

    public applyShelvedFilters(theme?: IValuesCollection) {
        // State may be is not initalized when a WS has no filter widget, but Apply must still work.
        if (this._state != null) {
            const filters = this._state.notAppliedFilters;
            const applyMode = theme != null ? getApplyMode(theme) : ApplyModes.AUTO;

            // Manual Mode still can work as refresh. See Issue 77711.
            let runActions = applyMode === ApplyModes.MANUAL;

            if (filters != null) {
                if (filters.attributeFilters != null) {
                    this.setAttributeFilterCollection(filters.attributeFilters, -1);
                    runActions = true;
                }

                if (filters.periodFilters != null) {
                    this.setPeriodFilters(filters.periodFilters, -1);
                    runActions = true;
                }

                this.dropNotAppliedFilters();
            }

            if (runActions) {
                if (applyMode === ApplyModes.MANUAL) {
                    this._glob.AppActions.workspaceApplyChanges(this._tab, this._namespace, 'filters');
                }

                this.riseWorkspaceSetStateEvent(0);
            }
        }
    }

    public applyModeIsOn(theme: IValuesCollection): boolean {
        if (!useApplyButton(theme)) {
            return false; // Auto Mode.
        }

        const applySwitcherState = getApplySwitcherState(theme);

        if (applySwitcherState !== ApplySwitcherStates.HIDDEN) {
            const { applySwitchers } = this._glob.ToolbarButtonsStore.getState();

            let switcherIsOn = applySwitchers != null && applySwitchers[this._tab];

            if (switcherIsOn == null) {
                switcherIsOn = applySwitcherState === ApplySwitcherStates.ON_BY_DEFAULT;
            }

            if (switcherIsOn) {
                return false;
            }
        }

        return true;
    }

    // delayInterval > 0 - set filter after timeout.
    // delayInterval = 0 - set filter immediatelly.
    // delayInterval < 0 - set filter, but do not rise an event.
    // Is used in ClockIn project. Must be public.
    public setAttributeFilterCollection(value: IGlobalAttributeFilterCollection, delayInterval: number = 0) {
        if (value == null) {
            this.dropAttributeFilter();
            return;
        }

        if (this._state == null) {
            this._state = {};
        }

        if (this._state.attributeFilters == null) {
            this._state.attributeFilters = {};
        }

        if (!compareObjects(this._state.attributeFilters, value)) {
            this._state.attributeFilters = $.extend(true, {}, value);
            this.riseWorkspaceSetStateEvent(delayInterval);
            return true;
        }

        return false;
    }

    public addToAttributeFilterCollection(
        newCollections: INewAttributeFilterColections,
        widgetID: number,
        delayInterval: number,
        resetFilters: boolean
    ) {
        let existingCollection = this.getNotAppliedAttributeFilterCollection(false);

        if (existingCollection != null) {
            // State collection is modified directly because several widgets can modify it at the same time in parallel.
            if (resetFilters) {
                dropTemporaryAttributeFilters(existingCollection);
            } else if (newCollections.toRemove != null) {
                for (let dataSourceID in newCollections.toRemove) {
                    const existingFilters = existingCollection[dataSourceID];

                    if (existingFilters != null) {
                        _.each(newCollections.toRemove[dataSourceID], (filterToRemove) => {
                            if (existingFilters[filterToRemove.id] != null) {
                                delete existingFilters[filterToRemove.id];
                            }
                        });
                    }
                }
            }

            if (!_.isEmpty(newCollections.newCollection)) {
                mergeAttributeFilterCollections(existingCollection, newCollections.newCollection, widgetID);
                this.riseWorkspaceSetStateEvent(delayInterval);
            } else if (resetFilters) {
                // See the second bug of Issue 83323.
                this.riseWorkspaceSetStateEvent(delayInterval);
            }
        } else if (!_.isEmpty(newCollections.newCollection)) {
            if (this._state == null) {
                this._state = {};
            }

            this._state.attributeFilters = $.extend(true, {}, newCollections.newCollection);
            this.riseWorkspaceSetStateEvent(delayInterval);
        }
    }

    public getAttributeFiltersWithDefaultValues(): IGlobalAttributeFilterCollection {
        const filterCollection = this.getAttributeFilterCollection();

        return _.mapObject(filterCollection, (filters) => {
            return _.mapObject(filters, (filter) => {
                let newFilter = $.extend(true, {}, filter);

                if (newFilter.values == null || newFilter.values.length === 0) {
                    newFilter.values = filter.defaultValue;
                }

                return newFilter;
            });
        });
    }

    private getResetAttributeFilters(): IGlobalAttributeFilterCollection {
        const filterCollection = this.getAttributeFilterCollection();

        if (filterCollection == null) {
            return null;
        }

        const result: IGlobalAttributeFilterCollection = {};

        _.each(filterCollection, (filters, dataSourceID) => {
            let newfilters: IGlobalAttributeFilters = null;

            _.each(filters, (filter, attributeID) => {
                if (!filter.clickToFilterAttribute) {
                    const newFilter = $.extend(true, {}, filter);

                    if (newFilter.values != null && newFilter.values.length > 0) {
                        newFilter.values = filter.defaultValue;
                    } else {
                        filter.values = [];
                    }

                    if (newfilters == null) {
                        newfilters = {};
                    }

                    newfilters[attributeID] = newFilter;
                }
            });

            if (newfilters != null) {
                result[dataSourceID] = newfilters;
            }
        });

        return result;
    }

    private isURLDatasource(value: IURLQueryValue) {
        return value.attr === URL_KEYS.Datasource && value.op === 'eq' && value.val != null;
    }

    public setFiltersFromURL(
        query: IURLQuery,
        workspaceID: number,
        staticWidgetID: number,
        theme: IValuesCollection,
        delayInterval: number = 0
    ): JQueryPromise<any> {
        const result = $.Deferred();

        if (query == null) {
            return result.resolve();
        }

        const dataSources: number[] = [];
        const dataSourcesStr: string[] = [];

        let keepFilters = false;

        _.each(query, (value) => {
            if (this.isURLDatasource(value)) {
                let id: number;

                if (Array.isArray(value.val)) {
                    id = value.val.length === 1 ? parseInt(value.val[0], 10) : null;
                } else {
                    id = parseInt(value.val[0], 10);
                }

                if (id != null && !Number.isNaN(id)) {
                    dataSources.push(id);
                    dataSourcesStr.push(id.toString());
                }
            } else if (!keepFilters && value.attr === URL_KEYS.KeepFilters) {
                let valArg: any;

                if (Array.isArray(value.val)) {
                    valArg = value.val.length > 0 ? value.val[0] : false;
                } else {
                    valArg = value.val;
                }

                if (typeof valArg === 'string') {
                    keepFilters = valArg === '1' || valArg === 'true';
                } else {
                    keepFilters = !!valArg;
                }
            }
        });

        this.dropNotAppliedFilters();

        let promise: JQuery.Promise<any>;

        if (dataSources.length > 0) {
            promise = this._glob.EntityModelsStore.loadModels(dataSources);
        } else {
            promise = $.Deferred().resolve().promise();
        }

        promise
            .done(() => {
                const promises: JQueryPromise<any>[] = [];
                const periodFilter: IPeriodFilter = {};

                let newAttributeFilterCollection: IGlobalAttributeFilterCollection;

                if (keepFilters) {
                    newAttributeFilterCollection = this.getAttributeFilterCollection();
                } else {
                    newAttributeFilterCollection = this.getResetAttributeFilters();
                }

                newAttributeFilterCollection = $.extend(true, {}, newAttributeFilterCollection);

                _.each(query, (value, key) => {
                    if (
                        key === URL_KEYS.PeriodStart ||
                        key === URL_KEYS.PeriodEnd ||
                        key === URL_KEYS.PeriodFrom ||
                        key === URL_KEYS.PeriodTo ||
                        key === URL_KEYS.FiscalMonth ||
                        key === URL_KEYS.Month ||
                        key === URL_KEYS.Quarter ||
                        key === URL_KEYS.Year ||
                        key === URL_KEYS.OneDayPeriod
                    ) {
                        this.setURLPeriodFilterValue(periodFilter, key, value.val);
                    } else if (dataSourcesStr.length > 0 && !this.isURLDatasource(value)) {
                        const settingPromise = this.setURLAttributeFilterValue(
                            key,
                            value,
                            dataSourcesStr,
                            newAttributeFilterCollection,
                            workspaceID,
                            staticWidgetID,
                            theme
                        );

                        if (settingPromise != null) {
                            promises.push(settingPromise);
                        }
                    }
                });

                $.when(...promises)
                    .done(() => {
                        if (keepFilters) {
                            this.addToPeriodFilter(periodFilter, null);
                        } else {
                            this.putPeriodFilter(periodFilter, -1);
                        }

                        this.setAttributeFilterCollection(newAttributeFilterCollection, delayInterval);
                        result.resolve();
                    })
                    .fail(() => {
                        result.resolve();
                    });
            })
            .fail(() => {
                result.resolve();
            });

        return result.promise();
    }

    private setURLPeriodFilterValue(periodFilter: IPeriodFilter, key: string, value: string[]) {
        if (key === URL_KEYS.PeriodStart || key === URL_KEYS.PeriodFrom) {
            periodFilter.from = value[0];

            if (periodFilter.variables == null) {
                periodFilter.variables = {};
            }

            periodFilter.variables.from = periodFilter.from;
        } else if (key === URL_KEYS.PeriodEnd || key === URL_KEYS.PeriodTo) {
            periodFilter.to = value[0];

            if (periodFilter.variables == null) {
                periodFilter.variables = {};
            }

            periodFilter.variables.to = periodFilter.to;
        } else if (key === URL_KEYS.FiscalMonth) {
            if (periodFilter.variables == null) {
                periodFilter.variables = {};
            }

            periodFilter.variables.fiscalMonth = parseInt(value[0]);
        } else if (key === URL_KEYS.Month) {
            periodFilter.month = _.map(value, (n) => {
                return parseInt(n);
            });
        } else if (key === URL_KEYS.Year) {
            periodFilter.year = _.map(value, (n) => {
                return parseInt(n);
            });
        } else if (key === URL_KEYS.Quarter) {
            periodFilter.quarter = _.map(value, (n) => {
                return parseInt(n);
            });
        } else if (key === URL_KEYS.OneDayPeriod) {
            if (periodFilter.options == null) {
                periodFilter.options = {};
            }

            periodFilter.options.oneDayPeriod = true;
        }
    }

    // Find existing or adds a new Click-to-Filter by data from URL.
    // operand(relation) is ignored here, because values are substitutes in the actual filter
    private setURLAttributeFilterValue(
        key: string,
        queryValue: IURLQueryValue,
        dataSources: string[],
        newAttributeFilterCollection: IGlobalAttributeFilterCollection,
        workspaceID: number,
        staticWidgetID: number,
        theme: IValuesCollection
    ): JQueryPromise<any> {
        const obj = parseURLAttribute(key, queryValue);

        let argValues = queryValue.val;

        if (obj.attributeName == null || argValues == null) {
            return null;
        }

        if (Array.isArray(argValues)) {
            argValues = argValues.map((value) => decodeParameterValueForURL(value));
        } else {
            argValues = [decodeParameterValueForURL(argValues)];
        }

        const { attributeName, isVariable, isExpression, attributeVariable } = obj;

        let attributeType = obj.attributeType;
        let attributeFilter: IGlobalAttributeFilter;
        let dataSourceID: string;

        for (const dsID in newAttributeFilterCollection) {
            if (dataSources.indexOf(dsID) >= 0) {
                const filterCollection = newAttributeFilterCollection[dsID];

                if (isVariable) {
                    attributeFilter = _.find(filterCollection, (filter) => {
                        return (
                            filter.valueType === 'variable' &&
                            variableNamesAreEqual(filter.attribute, attributeName.attribute)
                        );
                    });
                } else {
                    attributeFilter = _.find(filterCollection, (filter) => {
                        if (
                            !filter.clickToFilterAttribute &&
                            (attributeVariable == null ||
                                variableNamesAreEqual(attributeVariable, filter.options?.variableName))
                        ) {
                            if (filter.controlType === ATTRIBUTE_CONTROL_TYPES.TREE) {
                                const kp = getAttributesForTree(
                                    filter.attribute,
                                    filter.options,
                                    parseInt(dsID),
                                    this._glob,
                                    null
                                );

                                if (kp == null) {
                                    return;
                                }

                                return kp.attributeWithKey === attributeName.attribute;
                            } else {
                                return sameAttributes(filter, attributeName);
                            }
                        } else {
                            return false;
                        }
                    });

                    if (attributeFilter == null) {
                        attributeFilter = _.find(filterCollection, (filter) => {
                            return sameAttributes(filter, attributeName);
                        });
                    }
                }

                if (attributeFilter != null) {
                    dataSourceID = dsID;
                    break;
                }
            }
        }

        if (attributeFilter == null) {
            dataSourceID = dataSources[0];

            if (attributeType == null) {
                attributeType = this._glob.EntityModelsStore.getAttributeType(
                    attributeName,
                    parseInt(dataSourceID, 10)
                );
            }

            if (attributeType != null) {
                attributeFilter = {
                    clickToFilterAttribute: true
                };

                if (isVariable) {
                    attributeFilter.valueType = 'variable';
                    attributeFilter.controlType = convertAttributeTypeToControlType(attributeType);
                }

                if (attributeVariable != null) {
                    attributeFilter.options = { variableName: attributeVariable };
                }

                if (attributeType === ATTRIBUTE_TYPES.BOOLEAN || attributeType === ATTRIBUTE_TYPES.LOGICAL) {
                    attributeFilter.selectionType = 'single';
                } else {
                    attributeFilter.selectionType = 'multiply';
                }

                if (isExpression) {
                    attributeFilter.expression = attributeName.expression;
                    attributeFilter.id = JSON.stringify(attributeName.expression);
                } else {
                    attributeFilter.attribute = attributeFilter.id = attributeName.attribute;
                }

                let newFilters = newAttributeFilterCollection[dataSourceID];

                if (newFilters == null) {
                    newFilters = newAttributeFilterCollection[dataSourceID] = {};
                }

                newFilters[attributeFilter.id] = attributeFilter;
            }
        }

        if (attributeFilter == null) {
            return null;
        }

        if (attributeFilter.selectionType !== 'multiply' && argValues.length > 1) {
            let attributeTitle: string;

            if (isExpression) {
                attributeTitle = attributeName.expression.text;
            } else {
                attributeTitle = attributeName.attribute;
            }

            this._glob.AppActions.showNotification_Warning(
                `Single Select '${attributeTitle}' can show one value only, but URL has ${argValues.length} values specified.`
            );

            argValues = [argValues[0]];
        }

        const { dataQueryData, keySelect, attributeDataQuery } = getDataQueryData(
            attributeFilter,
            null,
            workspaceID,
            staticWidgetID
        );

        if (keySelect && (dataQueryData.attribute != null || dataQueryData.expression != null)) {
            const dataSourceIDInt = parseInt(dataSourceID, 10);
            const cultureValues = getCultureValues(theme);
            const result = this.makeDeferred();

            if (attributeFilter.controlType === ATTRIBUTE_CONTROL_TYPES.TREE) {
                const treeSelectAttrbuteData = getDataQueryDataForTree(
                    dataQueryData,
                    attributeDataQuery,
                    attributeFilter.options
                );
                const keyAttribute = this._glob.EntityModelsStore.getKeyAttribute(
                    treeSelectAttrbuteData.attribute,
                    dataSourceIDInt
                );
                const attributeWithKey = treeSelectAttrbuteData.attribute + ATTRIBUTE_SEPARATOR + keyAttribute;
                const filters = this.makeFiltersToLoadURLData(
                    argValues,
                    attributeWithKey,
                    dataSourceIDInt,
                    treeSelectAttrbuteData.filters,
                    theme,
                    cultureValues
                );

                this._glob.EntityModelsStore.loadTreeEntityValues(
                    dataSourceIDInt,
                    treeSelectAttrbuteData.attribute,
                    treeSelectAttrbuteData.parentAttribute,
                    undefined,
                    {},
                    treeSelectAttrbuteData.rootNodeID,
                    treeSelectAttrbuteData.labelAttribute,
                    filters
                )
                    .done((responce) => {
                        const displayValues = _.map(responce.nodes, (value) => {
                            const result: IDisplayValue = {
                                value: value.id,
                                displayValue: value.title
                            };

                            return result;
                        });

                        this.applyURLFilter(
                            { displayValues: displayValues },
                            newAttributeFilterCollection,
                            dataSourceID,
                            argValues,
                            attributeFilter
                        );
                        result.resolve();
                    })
                    .fail(() => {
                        result.resolve();
                    });
            } else {
                const filters = this.makeFiltersToLoadURLData(
                    argValues,
                    dataQueryData.keyAttribute.attribute,
                    dataSourceIDInt,
                    dataQueryData.filters,
                    theme,
                    cultureValues
                );

                this._glob.EntityModelsStore.loadEntityValues(dataSourceIDInt, {}, dataQueryData, filters)
                    .promise.done((responce) => {
                        this.applyURLFilter(
                            responce,
                            newAttributeFilterCollection,
                            dataSourceID,
                            argValues,
                            attributeFilter
                        );
                        result.resolve();
                    })
                    .fail(() => {
                        result.resolve();
                    });
            }

            return result.promise();
        } else {
            this.applyURLFilter(null, newAttributeFilterCollection, dataSourceID, argValues, attributeFilter);
            return null;
        }
    }

    private makeFiltersToLoadURLData(
        argValues: string[],
        attributeWithKey: string,
        dataSourceID: number,
        dataQueryFilters: IQueryFilter[],
        theme: IValuesCollection,
        cultureValues: ICultureValues
    ) {
        const result: IAQLFilter[] = [];
        const attributeType = this._glob.EntityModelsStore.getAttributeType(attributeWithKey, dataSourceID);
        const valueFilter = this.createAQLFilter(
            attributeWithKey,
            RELATIONS.IS_ONE_OF,
            argValues,
            dataSourceID,
            attributeType,
            null,
            theme,
            cultureValues
        );

        if (valueFilter != null) {
            result.push(valueFilter);
        }

        if (dataQueryFilters != null) {
            const localFilters = this.makeLocalFilter(
                dataQueryFilters,
                dataSourceID,
                undefined,
                theme,
                null,
                cultureValues,
                undefined
            );

            if (localFilters != null) {
                result.push(...localFilters);
            }
        }

        return result;
    }

    private applyURLFilter(
        response: IGetValuesResult,
        newAttributeFilterCollection: IGlobalAttributeFilterCollection,
        dataSourceID: string,
        argValues: string[],
        attributeFilter: IGlobalAttributeFilter
    ) {
        const filters = newAttributeFilterCollection[dataSourceID];
        const newValues = argValues.map((argValue) => {
            let displayValue: IDisplayValue = null;

            if (response != null && response.displayValues != null) {
                displayValue = response.displayValues.find((displayValue) => {
                    return displayValue.value === argValue;
                });
            }

            const result: IDisplayValue = {
                value: argValue
            };

            if (displayValue != null) {
                result.displayValue = displayValue.displayValue;
            }

            return result;
        });

        attributeFilter.values = newValues;

        if (filters[attributeFilter.id] == null) {
            filters[attributeFilter.id] = attributeFilter;
        }
    }

    public getShelvedAttributeFilterCollection(): IGlobalAttributeFilterCollection {
        if (this._state != null) {
            const notAppliedFilters = this._state.notAppliedFilters;

            if (notAppliedFilters != null && notAppliedFilters.attributeFilters != null) {
                return notAppliedFilters.attributeFilters;
            }
        }

        return null;
    }

    public getNotAppliedAttributeFilterCollection(makeCopy = true): IGlobalAttributeFilterCollection {
        let result = this.getShelvedAttributeFilterCollection();

        if (result == null) {
            result = this.getAttributeFilterCollection();
        }

        if (makeCopy !== false) {
            result = result != null ? $.extend(true, {}, result) : {};
        }

        return result;
    }

    public putAttributeFiltersOnShelf(value: IGlobalAttributeFilterCollection, triggerEvent: boolean): void {
        if (this._state == null) {
            this._state = {};
        }

        if (this._state.notAppliedFilters == null) {
            this._state.notAppliedFilters = {};
        }

        this._state.notAppliedFilters.attributeFilters = value;
        this._glob.AppActions.workspaceSaveState();

        if (triggerEvent) {
            this.triggerFiltersAreOnShelfEvent();
        }
    }

    public triggerFiltersAreOnShelfEvent() {
        this._glob.AppActions.filtersAreOnShelf(this._workspace, this._tab, this._namespace);
    }

    public getNotAppliedPeriodFilter(scopeOptions: IScopeOptions, makeCopy = true): IPeriodFilter {
        if (this._state == null) {
            this._state = {};
        }

        let result = this.getPeriodFilter(scopeOptions, this._state.notAppliedFilters?.periodFilters);

        if (makeCopy && result != null) {
            result = $.extend(true, {}, result);
        }

        return result;
    }

    private putPeriodFilterIntoCollection(value: IPeriodFilter, filters: IPeriodFilter[]): boolean {
        if (value == null || filters == null) {
            return false;
        }

        let index: number;

        if (value.scopeOptions == null) {
            index = filters.findIndex((filter) => filter.scopeOptions == null);
        } else {
            index = filters.findIndex((filter) => {
                return filter.scopeOptions?.scopeID === value.scopeOptions?.scopeID;
            });
        }

        if (index >= 0) {
            if (compareObjects(value, filters[index])) {
                return false;
            }

            filters[index] = { ...value };
        } else {
            filters.push({ ...value });
        }

        return true;
    }

    public addToPeriodFilter(value: IPeriodFilter, scopeOptions: IScopeOptions) {
        if (value == null) {
            return;
        }

        if (this._state == null) {
            this._state = {};
        }

        let periodFilter = this.getPeriodFilter(scopeOptions);

        if (periodFilter != null) {
            // Previous values as saved ones have priority over new values as default ones.
            periodFilter = {
                ...value,
                ...periodFilter
            };

            if (this._state.periodFilters == null) {
                this._state.periodFilters = [];
            }

            this.putPeriodFilterIntoCollection(periodFilter, this._state.periodFilters);
        } else if (scopeOptions != null && this._state.periodFilters != null) {
            // See Issue 100425.
            this._state.periodFilters.push(value);
        } else {
            this._state.periodFilters = [value];
        }
    }

    public putPeriodFilterOnShelf(value: IPeriodFilter, triggerEvent: boolean): void {
        if (this._state == null) {
            this._state = {};
        }

        let notAppliedFilters = this._state.notAppliedFilters;

        if (notAppliedFilters == null) {
            this._state.notAppliedFilters = notAppliedFilters = {};
        }

        if (notAppliedFilters.periodFilters == null) {
            notAppliedFilters.periodFilters = [];
        }

        this.putPeriodFilterIntoCollection(value, notAppliedFilters.periodFilters);
        this._glob.AppActions.workspaceSaveState();

        if (triggerEvent) {
            this.triggerFiltersAreOnShelfEvent();
        }
    }

    // delayInterval > 0 - set filter after timeout.
    // delayInterval = 0 - set filter immediatelly.
    // delayInterval < 0 - set filter, but do not rise event.
    public putPeriodFilter(value: IPeriodFilter, delayInterval: number) {
        if (this._state == null) {
            this._state = {};
        }

        let result: boolean;

        if (this._state.periodFilters == null) {
            this._state.periodFilters = [value];
            result = true;
        } else {
            result = this.putPeriodFilterIntoCollection(value, this._state.periodFilters);
        }

        if (result) {
            this.riseWorkspaceSetStateEvent(delayInterval);
        }

        return result;
    }

    // delayInterval > 0 - set filter after timeout.
    // delayInterval = 0 - set filter immediatelly.
    // delayInterval < 0 - set filter, but do not rise event.
    public setPeriodFilters(value: IPeriodFilter[], delayInterval: number) {
        if (value == null) {
            this.dropPeriodFilter();
            return;
        }

        if (this._state == null) {
            this._state = {};
        }

        if (!compareObjects(this._state.periodFilters, value)) {
            this._state.periodFilters = [...value];
            this.riseWorkspaceSetStateEvent(delayInterval);

            return true;
        }

        return false;
    }

    public registerAttributeFilterWidget(filterID: number) {
        this.getAttributeFilterWidgetDeferred(filterID);
    }

    private unregisterAttributeFilterWidget(filterID: number) {
        const widget = this._attributeFilterWidgets[filterID.toString()];

        if (widget != null) {
            widget.deferred.reject();
            delete this._attributeFilterWidgets[filterID.toString()];
        }
    }

    public getAttributeFilterWidgetDeferred(filterID: number) {
        let result = this._attributeFilterWidgets[filterID.toString()];

        if (result == null || (!result.inProcess && result.deferred.state() === 'resolved')) {
            result = this._attributeFilterWidgets[filterID.toString()] = {
                deferred: $.Deferred<INewAttributeFilterColections>()
            };
        }

        return result;
    }

    public registerPeriodFilterWidget(filterID: number) {
        this._periodFilterWidgets[filterID.toString()] = true;
    }

    private unregisterPeriodFilterWidget(filterID: number) {
        delete this._periodFilterWidgets[filterID.toString()];
    }

    public registerToolbarFilterWidget(filterID: number): boolean {
        if (this._toolbarFilterWidget != null && this._toolbarFilterWidget != filterID) {
            return false;
        }

        this._toolbarFilterWidget = filterID;

        return true;
    }

    private unregisterToolbarFilterWidget(filterID: number) {
        this._toolbarFilterWidget = null;
    }

    public filterWidgetExists(filterType?: FilterType) {
        switch (filterType) {
            case 'AttributeFilter':
                return !_.isEmpty(this._attributeFilterWidgets);

            case 'PeriodFilter':
                return !_.isEmpty(this._periodFilterWidgets);

            case 'ToolbarFilter':
                return this._toolbarFilterWidget != null;

            default:
                return (
                    !_.isEmpty(this._attributeFilterWidgets) ||
                    !_.isEmpty(this._periodFilterWidgets) ||
                    this._toolbarFilterWidget != null
                );
        }
    }

    public static unregisterFilterWidget(glob: IGlob, tab: number, filterType: FilterType, filterID: number) {
        const globalState = GlobalState.getGlobalState(glob, tab);

        if (globalState != null) {
            switch (filterType) {
                case 'AttributeFilter':
                    // Mark filter removed.
                    const existingFilterCollection = globalState.getNotAppliedAttributeFilterCollection(false);

                    if (existingFilterCollection != null) {
                        _.each(existingFilterCollection, (filters) => {
                            _.keys(filters).forEach((attributeID) => {
                                if (filters[attributeID].widgetID === filterID) {
                                    filters[attributeID].removed = true;
                                }
                            });
                        });
                    }

                    globalState.unregisterAttributeFilterWidget(filterID);
                    break;

                case 'PeriodFilter':
                    globalState.unregisterPeriodFilterWidget(filterID);
                    break;

                case 'ToolbarFilter':
                    globalState.unregisterToolbarFilterWidget(filterID);
                    break;

                default:
                    break;
            }
        }
    }

    private optionIncludeSubnodesIsOn(attributeOptions: IAttributeOptions): boolean {
        if (attributeOptions != null) {
            // const dataQuery = attributeOptions.dataQuery;
            // if (dataQuery != null && dataQuery.attribute != null && dataQuery.attribute.length > 0) {
            //     return dataQuery.includeSubnodes;
            // }
            // else {
            return attributeOptions.includeSubnodes;
            //}
        }

        return false;
    }

    public getFilterAsURLParameters(
        scopeOptions: IScopeOptions,
        filtersToAdd?: {
            attributeFilters?: IGlobalAttributeFilterCollection;
            periodFilter?: IPeriodFilter;
            excludePeriodFilter?: boolean;
        },
        tabTitle?: string
        //keepFilters?: boolean
    ): string {
        if (this._state == null) {
            return ''; //???
        }

        const params = [];

        if (tabTitle != null) {
            params.push(URL_KEYS.TabTitle + '=' + tabTitle);
        }

        // if (keepFilters != null) {
        //     params.push(URL_KEYS.KeepFilters + '=' + 1);
        // }

        let attributeFilterCollection = this._state.attributeFilters;

        if (filtersToAdd != null && filtersToAdd.attributeFilters != null) {
            attributeFilterCollection = $.extend(true, {}, attributeFilterCollection);
            mergeAttributeFilterCollections(attributeFilterCollection, filtersToAdd.attributeFilters, null);
        }

        if (attributeFilterCollection != null) {
            _.each(attributeFilterCollection, (attributeFilters, dataSourceID) => {
                const dataSourceIDInt = parseInt(dataSourceID, 10);

                params.push(URL_KEYS.Datasource + '=' + dataSourceID);

                _.each(attributeFilters, (attributeFilter) => {
                    const { values, options } = attributeFilter;

                    if (values == null || values.length === 0) {
                        return;
                    }

                    let attribute = attributeFilter.attribute;

                    if (attribute != null) {
                        if (attributeFilter.valueType === 'variable') {
                            const attributeType = convertControlTypeToAttributeType(attributeFilter.controlType);

                            attribute = normalizeVariableName(attribute) + URL_KEYS.Type + attributeType;
                        } else if (attributeFilter.valueType === 'timePart') {
                            attribute = URL_KEYS.TimePart + attribute;
                        } else {
                            if (attributeFilter.controlType === ATTRIBUTE_CONTROL_TYPES.TREE) {
                                const kp = getAttributesForTree(attribute, options, dataSourceIDInt, this._glob, null);

                                if (kp == null) {
                                    return;
                                }

                                attribute = kp.attributeWithKey;
                            }

                            if (options != null && options.variableName != null && options.variableName !== '') {
                                attribute += URL_KEYS.AttributeWithVariable + options.variableName;
                            }
                        }

                        attribute = encodeParameterForURL(attribute);
                    } else if (attributeFilter.expression != null) {
                        attribute = URL_KEYS.Expression + btoa(JSON.stringify(attributeFilter.expression));
                    } else {
                        return;
                    }

                    let functor: string = 'eq';
                    let value: string = '';

                    if (typeof values === 'string') {
                        value = encodeParameterValueForURL(values);
                    } else {
                        const valuesArray = [];

                        values.forEach((value) => {
                            if (value != null) {
                                if (value instanceof Date && attributeFilter.controlType === 'date') {
                                    valuesArray.push(
                                        Globalize.formatDate(value, {
                                            raw: 'yyyy-MM-dd'
                                        })
                                    );
                                } else {
                                    let result = value.value ?? value.displayValue;

                                    if (result == null) {
                                        result = (value as any).toString();
                                    }

                                    valuesArray.push(encodeParameterValueForURL(result));
                                }
                            }
                        });

                        value = valuesArray.join(',');
                    }

                    value = encodeParameterForURL(value);

                    if (options != null && options.relation != null) {
                        switch (options.relation) {
                            case RELATIONS.LESS:
                                functor = 'lt';
                                break;
                            case RELATIONS.LESS_OR_EQUAL:
                                functor = 'le';
                                break;
                            case RELATIONS.MORE:
                                functor = 'gt';
                                break;
                            case RELATIONS.MORE_OR_EQUAL:
                                functor = 'ge';
                                break;
                            case RELATIONS.NOT_EQUAL:
                            case RELATIONS.IS_NOT_ONE_OF:
                                functor = 'ne';
                                break;
                            default:
                                functor = 'eq';
                                break;
                        }
                    }

                    params.push(`${functor}(${attribute},"${value}")`);
                });
            });
        }

        let periodFilter: IPeriodFilter;

        if (filtersToAdd != null && filtersToAdd.periodFilter != null) {
            periodFilter = filtersToAdd.periodFilter;
        } else if (filtersToAdd == null || !filtersToAdd.excludePeriodFilter) {
            periodFilter = this.getPeriodFilter(scopeOptions);
        }

        if (periodFilter != null) {
            if (periodFilter.from != null) {
                params.push(`eq(${URL_KEYS.PeriodStart},"${periodFilter.from}")`);
            }

            if (periodFilter.to != null) {
                params.push(`eq(${URL_KEYS.PeriodEnd},"${periodFilter.to}")`);
            }

            if (periodFilter.variables?.fiscalMonth) {
                params.push(`eq(${URL_KEYS.FiscalMonth},"${periodFilter.variables?.fiscalMonth}")`);
            }

            if (periodFilter.month != null) {
                params.push(this.makeTimePartURLFilter(URL_KEYS.Month, periodFilter.month));
            }

            if (periodFilter.quarter != null) {
                params.push(this.makeTimePartURLFilter(URL_KEYS.Quarter, periodFilter.quarter));
            }

            if (periodFilter.year != null) {
                params.push(this.makeTimePartURLFilter(URL_KEYS.Year, periodFilter.year));
            }

            if (periodFilter.options != null && periodFilter.options.oneDayPeriod) {
                params.push(`eq(${URL_KEYS.OneDayPeriod},"${1}")`);
            }
        }

        return params.join('&');
    }

    private makeTimePartURLFilter(param: string, paramValue: number | number[]) {
        let val;

        if (_.isArray(paramValue) && paramValue.length > 0) {
            val = paramValue.join(',');
        } else {
            val = paramValue;
        }

        return `eq(${param},"${val}")`;
    }

    public putDrillDownFilters(value: IGlobalAttributeFilterCollection, drillDownWidgetID: number, level: number) {
        let drillDownFilterCollection = this._state.drillDownFilterCollection;

        if (drillDownFilterCollection == null) {
            drillDownFilterCollection = this._state.drillDownFilterCollection = {};
        }

        let drillDownFilters = drillDownFilterCollection[drillDownWidgetID];

        if (drillDownFilters == null || level === 0) {
            drillDownFilters = drillDownFilterCollection[drillDownWidgetID] = [];
        }

        drillDownFilters.push(value);

        this._glob.AppActions.workspaceSaveState();
        this.riseWorkspaceSetStateEvent(0);
    }

    public dropLastDrillDownFilters(drillDownWidgetID: number) {
        const drillDownFilterCollection = this._state.drillDownFilterCollection;

        if (drillDownFilterCollection == null) {
            return;
        }

        const drillDownFilters = drillDownFilterCollection[drillDownWidgetID];

        if (drillDownFilters == null || drillDownFilters.length === 0) {
            return;
        }

        if (drillDownFilters.length === 1) {
            delete drillDownFilterCollection[drillDownWidgetID];

            if (_.isEmpty(drillDownFilterCollection)) {
                this._state.drillDownFilterCollection = undefined;
            }
        } else {
            drillDownFilters.splice(drillDownFilters.length - 1, 1);
        }

        this._glob.AppActions.workspaceSaveState();
        this.riseWorkspaceSetStateEvent(0);
    }

    public dropAllDrillDownFilters(drillDownWidgetID: number) {
        const drillDownFilterCollection = this._state.drillDownFilterCollection;

        if (drillDownFilterCollection == null) {
            return;
        }

        const drillDownFilters = drillDownFilterCollection[drillDownWidgetID];

        if (drillDownFilters != null) {
            delete drillDownFilterCollection[drillDownWidgetID];

            if (_.isEmpty(drillDownFilterCollection)) {
                this._state.drillDownFilterCollection = undefined;
            }
        }
    }

    private makeDrillDownFilters(
        scopeOptions: IScopeOptions,
        dataSourceID: number,
        globalFilters?: IGlobalAttributeFilters
    ): IGlobalAttributeFilters {
        const drillDownFilterCollection = this._state.drillDownFilterCollection;

        if (drillDownFilterCollection != null && scopeOptions != null) {
            const drillDownWidgetID = scopeOptions.drillDownWidgetID;
            const drillDownFilters = drillDownFilterCollection[drillDownWidgetID];

            if (drillDownFilters != null) {
                const currentLevel = scopeOptions.drillDownlevel;

                if (currentLevel > 0 && currentLevel <= drillDownFilters.length) {
                    if (globalFilters != null) {
                        globalFilters = { ...globalFilters };
                    }

                    for (let index = 0; index < currentLevel; index++) {
                        const levelFilters = drillDownFilters[index][dataSourceID.toString()];

                        if (levelFilters != null) {
                            if (globalFilters == null) {
                                globalFilters = { ...levelFilters };
                            } else {
                                _.each(levelFilters, (filter, attributeID) => {
                                    const newAttributeID = createAttributeID(
                                        { attribute: attributeID },
                                        dataSourceID,
                                        globalFilters
                                    );

                                    globalFilters[newAttributeID] = { ...filter };
                                });
                            }
                        }
                    }
                }
            }
        }

        return globalFilters;
    }

    private makeScopeFilters(
        result: IAQLFilter[],
        scopeOptions: IScopeOptions,
        globalFilterControl: IGlobalFilterControl,
        dataSourceID: number,
        runTimeWidgetID: number
    ): void {
        if (scopeOptions == null || !Array.isArray(scopeOptions.filters) || scopeOptions.filters.length === 0) {
            return;
        }

        if (globalFilterControl == null || globalFilterControl.attributeFilter == null) {
            result.push(...scopeOptions.filters);
            return;
        }

        const { attributesToAllow, attributesToIgnore, attributesToOverride } = checkGlobalFilterControlAttributes(
            globalFilterControl.attributeFilter,
            dataSourceID,
            runTimeWidgetID,
            this._glob
        );

        if (Array.isArray(attributesToAllow) && attributesToAllow.length === 0) {
            return; // Filtering is not allowed.
        }

        let scopeFilters = [...scopeOptions.filters];

        if (Array.isArray(attributesToAllow) && attributesToAllow.length > 0) {
            const scopeFiltersToCopy: IAQLFilter[] = [];

            attributesToAllow.forEach(({ attribute }) => {
                scopeFilters.forEach((filter) => {
                    if (filter.attrib.join(ATTRIBUTE_SEPARATOR) === attribute) {
                        scopeFiltersToCopy.push({ ...filter });
                    }
                });
            });

            scopeFilters = scopeFiltersToCopy;
        }

        if (scopeFilters.length > 0 && Array.isArray(attributesToIgnore) && attributesToIgnore.length > 0) {
            attributesToIgnore.forEach(({ attribute }) => {
                scopeFilters = scopeFilters.filter((filter) => {
                    return filter.attrib.join(ATTRIBUTE_SEPARATOR) !== attribute;
                });
            });
        }

        if (scopeFilters.length > 0 && Array.isArray(attributesToOverride) && attributesToOverride.length > 0) {
            attributesToOverride.forEach(({ oldAttribute, newAttribute }) => {
                if (oldAttribute != null && newAttribute != null) {
                    scopeFilters.forEach((filter) => {
                        if (filter.attrib.join(ATTRIBUTE_SEPARATOR) === oldAttribute) {
                            filter.attrib = newAttribute.split(ATTRIBUTE_SEPARATOR);
                        }
                    });
                }
            });
        }

        if (scopeFilters.length > 0) {
            result.push(...scopeOptions.filters);
        }
    }

    public getGlobalFilterAttributeData(
        dataSourceID: number,
        globalFilterControl: IGlobalFilterControl,
        scopeOptions: IScopeOptions,
        runTimeWidgetID?: number,
        attributeFilterCollection?: IGlobalAttributeFilterCollection
    ): {
        useGlobalFiltering: boolean;
        globalFilters?: IGlobalAttributeFilters;
        deepGlobalFiltering?: boolean;
    } {
        let attributeFilters = this.getAttributeFilters(dataSourceID, scopeOptions, attributeFilterCollection);

        attributeFilters = this.makeDrillDownFilters(scopeOptions, dataSourceID, attributeFilters);

        let useGlobalFiltering = attributeFilters != null;
        let deepGlobalFiltering: boolean;

        if (useGlobalFiltering && globalFilterControl != null) {
            const { attributeFilter } = globalFilterControl;

            if (attributeFilter != null) {
                const { attributesToAllow, attributesToIgnore, attributesToOverride } =
                    checkGlobalFilterControlAttributes(attributeFilter, dataSourceID, runTimeWidgetID, this._glob);

                useGlobalFiltering = !Array.isArray(attributesToAllow) || attributesToAllow.length > 0;

                if (useGlobalFiltering) {
                    if (Array.isArray(attributesToAllow) && attributesToAllow.length > 0) {
                        const attributeFiltersCopy: IGlobalAttributeFilters = {};

                        attributesToAllow.forEach((attributeNameToAllow) => {
                            _.each(attributeFilters, (filter, attributeID) => {
                                if (hasConstantValueType(filter)) {
                                    if (
                                        (typeof attributeNameToAllow === 'string' &&
                                            filter.attribute === attributeNameToAllow) || // Old format.
                                        sameAttributes(filter, attributeNameToAllow)
                                    ) {
                                        attributeFiltersCopy[attributeID] = $.extend(true, {}, filter);
                                    }
                                }
                            });
                        });

                        attributeFilters = attributeFiltersCopy;
                    }

                    if (Array.isArray(attributesToIgnore) && attributesToIgnore.length > 0) {
                        const attributesToDrop: string[] = [];

                        attributesToIgnore.forEach((attributeNameToIgnore) => {
                            _.each(attributeFilters, (filter, attributeID) => {
                                if (hasConstantValueType(filter)) {
                                    let attributeToIgnore: string;

                                    if (typeof attributeNameToIgnore === 'string') {
                                        //Old format;
                                        attributeToIgnore = attributeNameToIgnore;
                                    } else if (attributeNameToIgnore.expression != null) {
                                        if (sameAttributes(filter, attributeNameToIgnore)) {
                                            attributesToDrop.push(attributeID);
                                        }
                                    } else {
                                        attributeToIgnore = attributeNameToIgnore.attribute;
                                    }

                                    if (attributeToIgnore != null) {
                                        const filterAttribute = filter.attribute;

                                        if (
                                            filterAttribute != null &&
                                            (filterAttribute === attributeToIgnore ||
                                                filterAttribute.indexOf(attributeToIgnore + ATTRIBUTE_SEPARATOR) === 0)
                                        ) {
                                            attributesToDrop.push(attributeID);
                                        }
                                    }
                                }
                            });
                        });

                        if (attributesToDrop.length > 0) {
                            attributeFilters = $.extend(true, {}, attributeFilters);

                            attributesToDrop.forEach((attributeID) => {
                                delete attributeFilters[attributeID];
                            });
                        }
                    }

                    if (_.isEmpty(attributeFilters)) {
                        return {
                            useGlobalFiltering: false
                        };
                    }

                    if (Array.isArray(attributesToOverride) && attributesToOverride.length > 0) {
                        attributeFilters = $.extend(true, {}, attributeFilters);

                        const filtersToChange: IGlobalAttributeFilter[] = [];

                        attributesToOverride.forEach(({ oldAttribute, newAttribute }) => {
                            if (oldAttribute != null && newAttribute != null) {
                                _.each(attributeFilters, (filter, attributeID) => {
                                    if (hasConstantValueType(filter) && filter.attribute === oldAttribute) {
                                        filter.attribute = newAttribute;

                                        if (filter.id == null) {
                                            filter.id = attributeID;
                                        }

                                        filtersToChange.push(filter);
                                    }
                                });
                            }
                        });

                        if (filtersToChange.length > 0) {
                            filtersToChange.forEach((filter) => {
                                delete attributeFilters[filter.id];

                                const newID = createAttributeID(filter, dataSourceID, attributeFilters);

                                filter.id = newID;
                                attributeFilters[newID] = filter;
                            });
                        }
                    }
                }
            }

            deepGlobalFiltering = !globalFilterControl.ignoreAllDeepFiltering;
        }

        return {
            useGlobalFiltering: useGlobalFiltering,
            globalFilters: attributeFilters,
            deepGlobalFiltering: deepGlobalFiltering
        };
    }

    private getDefaultAttributeType(value: string | IAttributeName, dataSourceID: number) {
        return this._glob.EntityModelsStore.getDefaultAttributeType(value, dataSourceID);
    }

    public formatValueByType_WithMessage(
        value: any,
        attributeType: string,
        runTimeWidgetID: number,
        intervals?: IIntervals,
        timeZone?: DateTimeFunctions.ITimeZone
    ): any {
        let result = formatValueByType(value, attributeType, intervals, timeZone);

        if (result === undefined) {
            let typeForMessage: string;

            switch (attributeType) {
                case ATTRIBUTE_TYPES.INTEGER:
                    typeForMessage = 'Integer';
                    break;

                case ATTRIBUTE_TYPES.REAL:
                    typeForMessage = 'Real';
                    break;

                default:
                    if (intervals != null && intervals.timePart != null) {
                        typeForMessage = 'Time Part';
                    } else {
                        typeForMessage = attributeType;
                    }
                    break;
            }

            this._glob.AppActions.showNotification_Fail(
                `Error in a Filter: Fail to convert '${JSON.stringify(value)}' value to ${typeForMessage}.`,
                runTimeWidgetID,
                {
                    showInPopup: runTimeWidgetID == null
                }
            );
        }

        return result;
    }

    private addAQLFilterToArray(filter: IAQLFilter, result: IAQLFilter[]) {
        if (filter != null) {
            const filterStr = JSON.stringify(filter);

            if (result.findIndex((existingFilter) => filterStr === JSON.stringify(existingFilter)) < 0) {
                result.push(filter);
            }
        }
    }

    private makeAttributeGlobalFilter(
        result: IAQLFilter[],
        globalFilterControl: IGlobalFilterControl,
        dataSourceID: number,
        runTimeWidgetID: number,
        theme: IValuesCollection,
        cultureValues: ICultureValues,
        scopeOptions: IScopeOptions
    ): void {
        const { globalFilters, useGlobalFiltering, deepGlobalFiltering } = this.getGlobalFilterAttributeData(
            dataSourceID,
            globalFilterControl,
            scopeOptions,
            runTimeWidgetID
        );

        if (globalFilters == null || !useGlobalFiltering) {
            return;
        }

        for (let attributeID in globalFilters) {
            const filter = globalFilters[attributeID];
            const attribute = filter.attribute;

            if (attribute == null && filter.expression == null) {
                continue;
            }

            const { options } = filter;

            let values: string[];

            if (filter.values != null) {
                if (Array.isArray(filter.values)) {
                    values = _.map(filter.values, (value) => {
                        if (typeof value === 'string') {
                            return value;
                        } else {
                            return value.value;
                        }
                    });
                } else {
                    values = [filter.values];
                }
            }

            const numberOfValues = values != null && values.length > 0 ? values.length : 0;

            let relation = options != null ? options.relation : null;

            if (relation == null) {
                if (numberOfValues > 0) {
                    relation = numberOfValues === 1 ? RELATIONS.EQUAL : AQL.IN;
                } else {
                    relation = RELATIONS.EQUAL;
                }
            }

            let deepFiltering = deepGlobalFiltering;

            if (deepFiltering !== false && options != null) {
                deepFiltering = options.deepFiltering;
            }

            let attributeType: string;

            if (hasConstantValueType(filter)) {
                attributeType = this.getDefaultAttributeType(filter, dataSourceID);

                const mustHaveValue = !relationDoesNotAllowToHaveValue(relation);

                if (numberOfValues === 0 && mustHaveValue) {
                    continue;
                }

                let aqlAttribute: string | IExpression;
                let parentAttribute: string;

                if (filter.expression == null) {
                    // Check attribute type for filtering by tree and attribute substitution
                    const entityType = this._glob.EntityModelsStore.getAttributeType(attribute, dataSourceID);

                    aqlAttribute = attribute;

                    if (mustHaveValue && filter.controlType === 'tree' && entityType === ATTRIBUTE_TYPES.ENUMERATION) {
                        const kp = getAttributesForTree(attribute, options, dataSourceID, this._glob, runTimeWidgetID);

                        if (kp == null) {
                            continue;
                        }

                        aqlAttribute = kp.attributeWithKey;
                        attributeType = this.getDefaultAttributeType(aqlAttribute, dataSourceID);

                        if (kp.parentAttribute != null && this.optionIncludeSubnodesIsOn(options)) {
                            relation = RELATIONS.IS_SUBNODE_OF;
                            parentAttribute = attribute + ATTRIBUTE_SEPARATOR + kp.parentAttribute;
                        }
                    }
                } else {
                    aqlAttribute = this.expressionBindVariables(
                        filter.expression,
                        dataSourceID,
                        runTimeWidgetID,
                        scopeOptions,
                        cultureValues
                    );

                    if (aqlAttribute == null) {
                        continue;
                    }
                }

                const aqlFilter = this.createAQLFilter(
                    aqlAttribute,
                    relation,
                    values,
                    dataSourceID,
                    attributeType,
                    runTimeWidgetID,
                    theme,
                    cultureValues,
                    filter.intervals,
                    filter.timeZone,
                    deepFiltering,
                    parentAttribute
                );

                this.addAQLFilterToArray(aqlFilter, result);
            } else if (filter.valueType === 'timePart') {
                if (numberOfValues === 0) {
                    continue;
                }

                let periodFilter = _.find(result, (filter) => {
                    return filter.type === AQL.TYPE_PERIOD;
                });

                if (periodFilter == null) {
                    periodFilter = {
                        type: AQL.TYPE_PERIOD
                    };
                }

                if (this.setGlobalFilterControlToPeriodFilter(periodFilter, globalFilterControl)) {
                    const newValues: number[] = this.formatValueByType_WithMessage(
                        values,
                        ATTRIBUTE_TYPES.INTEGER,
                        runTimeWidgetID
                    );

                    let timePartValues: any[] = periodFilter[attribute];

                    if (timePartValues == null) {
                        timePartValues = newValues;
                    } else {
                        if (!Array.isArray(timePartValues)) {
                            timePartValues = [timePartValues];
                        }

                        timePartValues = this.formatValueByType_WithMessage(
                            timePartValues,
                            ATTRIBUTE_TYPES.INTEGER,
                            runTimeWidgetID
                        );

                        _.each(newValues, (value) => {
                            if (
                                _.findIndex(timePartValues, (tpValue) => {
                                    return tpValue === value;
                                }) < 0
                            ) {
                                timePartValues.push(value);
                            }
                        });
                    }

                    const intervalsData = GlobalState.getIntervalsDataForAQL(
                        filter.intervals,
                        timePartValues,
                        filter.timeZone,
                        attributeType,
                        theme,
                        cultureValues
                    );

                    if (intervalsData.values != null) {
                        timePartValues = intervalsData.values;
                    }

                    if (intervalsData.firstWeekDay != null) {
                        periodFilter.firstWeekDay = intervalsData.firstWeekDay;
                    }

                    if (intervalsData.timePeriodStartMonth != null) {
                        periodFilter.timePeriodStartMonth = intervalsData.timePeriodStartMonth;
                    }

                    periodFilter[attribute] = timePartValues;

                    result.push(periodFilter);
                }
            }
        }
    }

    public makeGlobalFilter(
        dataSourceID: number,
        globalFilterControl: IGlobalFilterControl,
        runTimeWidgetID: number,
        theme: IValuesCollection,
        cultureValues: ICultureValues,
        scopeOptions: IScopeOptions
    ): IAQLFilter[] {
        const result: IAQLFilter[] = [];

        this.makePeriodFilter(result, scopeOptions, globalFilterControl);
        this.makeScopeFilters(result, scopeOptions, globalFilterControl, dataSourceID, runTimeWidgetID);
        this.makeAttributeGlobalFilter(
            result,
            globalFilterControl,
            dataSourceID,
            runTimeWidgetID,
            theme,
            cultureValues,
            scopeOptions
        );

        return result;
    }

    public makeDeferred() {
        const result = $.Deferred();

        this._deferreds.push(result);
        return result;
    }

    public makeFiltersForWidget(
        dataSourceID: number,
        localFilter: IAttrQueryFilterFieldValue,
        runTimeWidgetID: number,
        timeZone: DateTimeFunctions.ITimeZone,
        theme: IValuesCollection,
        cultureValues: ICultureValues,
        scopeOptions: IScopeOptions,
        masterFilter?: IAQLFilter[]
    ): JQueryDeferred<IAQLFilter[]> {
        const result = $.Deferred<IAQLFilter[]>();
        const filterDeferreds: JQueryDeferred<any>[] = [];

        for (let widgetID in this._attributeFilterWidgets) {
            filterDeferreds.push(this._attributeFilterWidgets[widgetID].deferred);
        }

        $.when(this._glob.EntityModelsStore.loadModels([dataSourceID]), ...filterDeferreds, ...this._deferreds)
            .done(() => {
                let localFilters: IAQLFilter[];
                let globalFilterControl: IGlobalFilterControl;

                if (localFilter != null) {
                    localFilters = this.makeLocalFilter(
                        localFilter.filters,
                        dataSourceID,
                        timeZone,
                        theme,
                        runTimeWidgetID,
                        cultureValues,
                        scopeOptions
                    );

                    if (localFilters == null) {
                        result.reject();
                        return;
                    }

                    globalFilterControl = localFilter.globalFilterControl;
                }

                if (masterFilter != null) {
                    localFilters = localFilters != null ? localFilters.concat([...masterFilter]) : [...masterFilter];
                }

                const globalFilter = this.makeGlobalFilter(
                    dataSourceID,
                    globalFilterControl,
                    runTimeWidgetID,
                    theme,
                    cultureValues,
                    scopeOptions
                );
                const { aqlFilter } = this.mergeGlobalAndLocalFilters(globalFilter, localFilters, dataSourceID);

                result.resolve(aqlFilter);
            })
            .fail(() => {
                result.reject();
            });

        return result;
    }

    public makeGlobalFilterAsync(
        dataSourceID: number,
        globalFilterControl: IGlobalFilterControl,
        runTimeWidgetID: number,
        theme: IValuesCollection,
        cultureValues: ICultureValues,
        scopeOptions: IScopeOptions
    ): JQueryDeferred<IAQLFilter[]> {
        const result = $.Deferred<IAQLFilter[]>();

        this._glob.EntityModelsStore.loadModels([dataSourceID]).done(() => {
            const filters = this.makeGlobalFilter(
                dataSourceID,
                globalFilterControl,
                runTimeWidgetID,
                theme,
                cultureValues,
                scopeOptions
            );

            result.resolve(filters);
        });

        return result;
    }

    public createAQLFilter(
        attribute: string | IExpression,
        relation: string,
        value: any,
        dataSourceID: number,
        attributeType: string,
        runTimeWidgetID: number,
        theme: IValuesCollection,
        cultureValues: ICultureValues,
        intervals?: IIntervals,
        timeZone?: DateTimeFunctions.ITimeZone,
        deepFiltering?: boolean,
        parentAttribute?: string,
        label?: string
    ): IAQLFilter {
        if (timeZone == null) {
            timeZone = DateTimeFunctions.getTimeZoneFromTheme(theme);
        }

        let aqlValue = this.formatValueByType_WithMessage(value, attributeType, runTimeWidgetID, intervals, timeZone);

        //When conversion failed is set 'undefined'.
        if (aqlValue === undefined) {
            return;
        }

        let aqlRelation: string;
        let isSubnodeOfRelation: boolean;

        switch (relation) {
            case RELATIONS.IS_ONE_OF:
                aqlRelation = AQL.IN;
                break;

            case RELATIONS.IS_NOT_ONE_OF:
                aqlRelation = AQL.NOT_IN;
                break;

            case RELATIONS.NOT_LIKE:
                aqlRelation = AQL.NOT_LIKE;
                break;

            case RELATIONS.IS_NULL:
                aqlRelation = AQL.IS_NULL;
                aqlValue = undefined;
                break;

            case RELATIONS.IS_NOT_NULL:
                aqlRelation = AQL.IS_NOT_NULL;
                aqlValue = undefined;
                break;

            case RELATIONS.EXISTS:
                aqlRelation = AQL.EXISTS;
                aqlValue = undefined;
                break;

            case RELATIONS.NOT_EXISTS:
                aqlRelation = AQL.NOT_EXISTS;
                aqlValue = undefined;
                break;

            case RELATIONS.IS_SUBNODE_OF:
                aqlRelation = AQL.IS_SUBNODE_OF;
                isSubnodeOfRelation = true;
                break;

            case RELATIONS.IS_NOT_SUBNODE_OF:
                aqlRelation = AQL.IS_NOT_SUBNODE_OF;
                isSubnodeOfRelation = true;
                break;

            default:
                if (attributeType === ATTRIBUTE_TYPES.LOGICAL) {
                    if (logicalExpressionIsOff(aqlValue)) {
                        return null;
                    }

                    aqlRelation = AQL.LOGICAL;
                    aqlValue = undefined;
                } else {
                    aqlRelation = relation;
                }
        }

        let result: IAQLFilter;

        if (typeof attribute === 'string') {
            result = {
                attrib: attribute.split(ATTRIBUTE_SEPARATOR),
                type: aqlRelation,
                dataSourceID: dataSourceID
            };
        } else {
            result = {
                syntaxTree: attribute.syntaxTree,
                rettype: attribute.rettype,
                type: aqlRelation,
                dataSourceID: dataSourceID
            };
        }

        if (deepFiltering === false) {
            result.deepFiltering = deepFiltering;
        }

        const intervalsData = GlobalState.getIntervalsDataForAQL(
            intervals,
            aqlValue,
            timeZone,
            attributeType,
            theme,
            cultureValues
        );

        if (intervalsData.values != null) {
            aqlValue = intervalsData.values;
        }

        if (intervalsData.timePart != null) {
            result.timePart = intervalsData.timePart;
        }

        if (intervalsData.firstWeekDay != null) {
            result.firstWeekDay = intervalsData.firstWeekDay;
        }

        if (intervalsData.timePeriodStartMonth != null) {
            result.timePeriodStartMonth = intervalsData.timePeriodStartMonth;
        }

        if (parentAttribute != null) {
            result.attribParent = parentAttribute.split(ATTRIBUTE_SEPARATOR);
        }

        if (label != null) {
            result.label = label;
        }

        if (aqlValue !== undefined) {
            if (variableNamesAreEqual(aqlValue, VARIABLE_USER_ID)) {
                result.variable = VARIABLE_USER_ID;
            } else {
                result.val = aqlValue;
            }

            if (aqlRelation === AQL.IN || aqlRelation === AQL.NOT_IN) {
                if (aqlValue.length === 0) {
                    return null; // Empty array means no filtering.
                }

                if (!Array.isArray(aqlValue)) {
                    let valueArray: any[];

                    if (typeof aqlValue === 'string') {
                        valueArray = aqlValue.split(',');

                        for (let i = 0; i < valueArray.length; i++) {
                            valueArray[i] = valueArray[i].trim();
                        }
                    } else {
                        valueArray = [aqlValue];
                    }

                    result.val = valueArray;
                }

                // Use EQUAL relations for a single value for optimization.
                if (Array.isArray(result.val) && result.val.length === 1) {
                    if (aqlRelation === AQL.NOT_IN) {
                        result.relation = RELATIONS.NOT_EQUAL;
                    } else {
                        result.relation = RELATIONS.EQUAL;
                    }

                    result.type = AQL.RELATION;
                    result.val = result.val[0];
                }
            } else if (!isSubnodeOfRelation) {
                if (Array.isArray(aqlValue) && aqlValue.length > 0) {
                    result.val = aqlValue[0];
                }

                if (aqlRelation === AQL.LIKE || aqlRelation === AQL.NOT_LIKE) {
                    const val = result.val.toString();

                    if (val.indexOf('%') === -1) {
                        result.val = '%' + val + '%';
                    }
                } else {
                    result.type = AQL.RELATION;
                    result.relation = relation;
                }
            }
        }

        return result;
    }

    public applyDinamicFiscalMonth(intervals: IIntervals, scopeOptions: IScopeOptions): IIntervals {
        const periodFilter = this.getPeriodFilter(scopeOptions);

        let result = intervals;

        if (periodFilter != null) {
            result = $.extend(true, {}, result);

            if (result.timePeriodStartMonth === -1) {
                result.timePeriodStartMonth = periodFilter.variables?.fiscalMonth;
            }

            if (result.timePeriods?.timePeriodStartMonth === -1) {
                result.timePeriods.timePeriodStartMonth = periodFilter.variables?.fiscalMonth;
            }
        }

        return result;
    }

    public getActualFiscalFirstMonth(cultureValues: ICultureValues, scopeOptions: IScopeOptions) {
        const periodFilter = this.getPeriodFilter(scopeOptions);

        let result: number = 1;

        if (cultureValues != null) {
            result = cultureValues.fiscalFirstMonth;
        }
        if (periodFilter != null) {
            result = periodFilter.variables?.fiscalMonth || result;
        }

        return result;
    }

    private static getIntervalsDataForAQL(
        intervals: IIntervals,
        values: number[],
        timeZone: DateTimeFunctions.ITimeZone,
        attributeType: string,
        theme: IValuesCollection,
        cultureValues: ICultureValues
    ) {
        const { timePart, firstWeekDay } = convertIntervalValueToAttrQueryParam(
            intervals,
            timeZone,
            attributeType,
            theme,
            cultureValues
        );

        if (values != null && firstWeekDay != null && timePart === TIME_PART_TYPES.DAY_OF_WEEK) {
            // Shift Day of Week by First Day Week.
            values = _.map(Array.isArray(values) ? values : [values], (item) => {
                let newValue = item - (firstWeekDay - 1);

                if (newValue < 1) {
                    newValue += 7;
                }

                return newValue;
            });
        }

        let timePeriodStartMonth: number;

        if (intervals != null && intervals.timePeriodStartMonth != null) {
            timePeriodStartMonth =
                typeof intervals.timePeriodStartMonth === 'string'
                    ? parseInt(intervals.timePeriodStartMonth, 10)
                    : intervals.timePeriodStartMonth;

            if (timePeriodStartMonth == null) {
                //EVG 01.06.2020: Obsolete. Drop it.
                timePeriodStartMonth = (intervals as any).timePartStartMonth;

                if (timePeriodStartMonth != null) {
                    timePeriodStartMonth =
                        typeof timePeriodStartMonth === 'string' ? parseInt(timePeriodStartMonth, 10) : null;
                }
            }
        }

        return {
            timePart: timePart,
            values: values,
            firstWeekDay: firstWeekDay,
            timePeriodStartMonth: timePeriodStartMonth
        };
    }

    public getAllVariables(
        dataSourceID: number,
        cultureValues: ICultureValues,
        scopeOptions: IScopeOptions,
        globalFilterCollection?: IGlobalAttributeFilterCollection,
        periodFilter?: IPeriodFilter,
        getAppliedData?: boolean
    ): IGlobalAttributeFilter[] {
        const result: IGlobalAttributeFilter[] = [];

        if (globalFilterCollection == null) {
            globalFilterCollection = getAppliedData
                ? this.getAttributeFilterCollection()
                : this.getNotAppliedAttributeFilterCollection();
        }

        if (globalFilterCollection != null) {
            let dataSourceIDStr: string;

            if (dataSourceID != null) {
                dataSourceIDStr = dataSourceID.toString();

                const globalFilters = globalFilterCollection[dataSourceIDStr];

                // Add Variables of the Data Source.
                _.each(globalFilters, (filter) => {
                    if (
                        filter.valueType === 'variable' ||
                        (filter.options != null && filter.options.variableName != null)
                    ) {
                        result.push(filter);
                    }
                });
            }

            // Add Variables from other Data Sources.
            _.each(globalFilterCollection, (filters, filterDataSourceID) => {
                if (filterDataSourceID !== dataSourceIDStr) {
                    _.each(filters, (filter) => {
                        if (
                            filter.valueType === 'variable' ||
                            (filter.options != null && filter.options.variableName != null)
                        ) {
                            result.push(filter);
                        }
                    });
                }
            });
        }

        if (periodFilter == null) {
            periodFilter = getAppliedData
                ? this.getPeriodFilter(scopeOptions)
                : this.getNotAppliedPeriodFilter(scopeOptions);
        }

        const periodFilterVariables = periodFilter?.variables;
        const fiscalMonth = periodFilterVariables?.fiscalMonth || cultureValues?.fiscalFirstMonth;

        if (fiscalMonth != null) {
            result.push({
                attribute: VARIABLE_FISCAL_MONTH,
                values: [{ value: fiscalMonth.toString() }],
                controlType: ATTRIBUTE_CONTROL_TYPES.INTEGER,
                valueType: 'variable',
                selectionType: 'single'
            });
        }

        if (periodFilterVariables != null) {
            const { from, to } = periodFilterVariables;

            result.push({
                attribute: VARIABLE_PERIOD_START,
                values: [{ value: from != null ? from.toString() : null }],
                controlType: ATTRIBUTE_CONTROL_TYPES.DATETIME,
                valueType: 'variable',
                selectionType: 'single',
                allowNull: true
            });

            result.push({
                attribute: VARIABLE_PERIOD_END,
                values: [{ value: to != null ? to.toString() : null }],
                controlType: ATTRIBUTE_CONTROL_TYPES.DATETIME,
                valueType: 'variable',
                selectionType: 'single',
                allowNull: true
            });
        }

        if (result.findIndex((variable) => variable.attribute === VARIABLE_USER_ID) < 0) {
            const logIn = this._glob.AppStore.getAuthenticationData();

            result.push({
                attribute: VARIABLE_USER_ID,
                values: [{ value: logIn.userid.toString() }],
                controlType: ATTRIBUTE_CONTROL_TYPES.INTEGER,
                valueType: 'variable',
                selectionType: 'single'
            });
        }

        return result;
    }

    private showNotification_Warning(message: string, defaultMessage: string, runTimeWidgetID: number) {
        let errorMessage: string;

        if (message != null) {
            message = message.trim();

            if (message.length > 0) {
                errorMessage = message;
            }
        } else {
            errorMessage = defaultMessage;
        }

        if (errorMessage != null) {
            this._glob.AppActions.showNotification_Warning(errorMessage, runTimeWidgetID);
        }
    }

    public makeLocalFilter(
        filters: IQueryFilter[],
        dataSourceID: number,
        timeZone: DateTimeFunctions.ITimeZone,
        theme: IValuesCollection,
        runTimeWidgetID: number,
        cultureValues: ICultureValues,
        scopeOptions: IScopeOptions,
        lookInNotAppliedFilters?: boolean,
        doNotBindVariables?: boolean
    ): IAQLFilter[] {
        const result: IAQLFilter[] = [];

        if (filters == null) {
            return result;
        }

        if (cultureValues == null) {
            console.log(
                'WARNING: cultureValues are not specified for makeLocalFilter. It means that calculation of firstWeekDay or fiscalFirstMonth might be wrong.'
            );
            console.log('WARNING: If they are not needed, set "cultureValues" parameter to {}, but not null.');
        }

        let periodFilter: IPeriodFilter;

        for (let i = 0; i < filters.length; i++) {
            const localFilter = filters[i];

            if (localFilter == null) {
                continue;
            }

            let newFilter: IAQLFilter = null;

            if (localFilter.attribute != null || localFilter.expression != null) {
                const relation = localFilter.relation;
                const requreValue = relation === RELATIONS.REQUIRE_VALUE;

                let attribute: string | IExpression;
                let attributeType: string;

                // relation can be undefined for Logical Expressions.
                if (relation !== null && relation !== '') {
                    const options = localFilter.options;
                    const isSubnodeOfRelation = isIsSubnodeOfRelation(relation);
                    const valueType = getValueType(localFilter);

                    let globalFilterCollection: IGlobalAttributeFilterCollection;

                    if (lookInNotAppliedFilters) {
                        globalFilterCollection = this.getNotAppliedAttributeFilterCollection();
                    } else {
                        globalFilterCollection = this.getAttributeFilterCollection();
                    }

                    let attributeName = localFilter.attribute;
                    let value = localFilter.value;
                    let intervals = localFilter.intervals;
                    let parentAttribute: string;

                    if (attributeName != null) {
                        attribute = attributeName;

                        if (
                            isSubnodeOfRelation ||
                            (options != null && options.controlType === ATTRIBUTE_CONTROL_TYPES.TREE)
                        ) {
                            const kp = getAttributesForTree(
                                attribute,
                                options,
                                dataSourceID,
                                this._glob,
                                runTimeWidgetID
                            );

                            if (kp == null) {
                                continue; // Drop the filter.
                            }

                            if (kp.parentAttribute != null) {
                                parentAttribute = attribute + ATTRIBUTE_SEPARATOR + kp.parentAttribute;
                            }

                            attribute = kp.attributeWithKey;

                            if (isSubnodeOfRelation && parentAttribute == null) {
                                this._glob.AppActions.showNotification_Warning(
                                    `Fail to find Parent Attribute in Local Filter for Attribute '${attribute}' with ${RELATIONS.IS_SUBNODE_OF} relation. The filter is ignored.`,
                                    runTimeWidgetID
                                );

                                continue; // Drop the filter.
                            }
                        }

                        attributeType = this.getDefaultAttributeType(attribute, dataSourceID);

                        if (requreValue) {
                            const attributeFilters = this.getAttributeFilters(
                                dataSourceID,
                                scopeOptions,
                                globalFilterCollection,
                                true
                            );

                            let filterWithValue: IGlobalAttributeFilter;

                            if (attributeFilters != null) {
                                filterWithValue = this.findGlobalFilterWithValue(attributeFilters, localFilter);
                            }

                            const exchangeObject = this.findExchangeObjectWithValue(filters, localFilter);

                            if (!(filterWithValue != null || exchangeObject != null)) {
                                this.showNotification_Warning(
                                    localFilter.label,
                                    `A value for a Local Filter with '${attributeName}' Attribute must be specified in Attribute Filter.`,
                                    runTimeWidgetID
                                );
                                return null; // Cancel creation.
                            } else {
                                // Require Value filter does not go to AQL.
                                continue;
                            }
                        }
                    } else {
                        if (!doNotBindVariables) {
                            attribute = this.expressionBindVariables(
                                localFilter.expression,
                                dataSourceID,
                                runTimeWidgetID,
                                scopeOptions,
                                cultureValues,
                                globalFilterCollection,
                                requreValue,
                                localFilter.label
                            );

                            if (attribute == null) {
                                if (requreValue) {
                                    return null;
                                }

                                continue;
                            }
                        } else {
                            attribute = localFilter.expression;
                        }

                        attributeType = getExpressionType(attribute);
                        attributeName = attribute.text || 'expression';
                    }

                    if (valueType === 'variable') {
                        if (periodFilter === undefined) {
                            periodFilter = this.getNotAppliedPeriodFilter(scopeOptions, false);
                        }

                        const allVariables = this.getAllVariables(
                            dataSourceID,
                            cultureValues,
                            scopeOptions,
                            globalFilterCollection,
                            periodFilter
                        );

                        const variableName = value as string;

                        // VARIABLE_USER_ID is substituted by backend. Here it must be as is.
                        if (variableNamesAreEqual(variableName, VARIABLE_USER_ID)) {
                            value = VARIABLE_USER_ID;
                            attributeType = ATTRIBUTE_TYPES.INTEGER;
                        } else {
                            const variables = findVariables(allVariables, variableName, false);

                            let errorMessage: string = null;

                            if (variables != null) {
                                const variable = variables.find((variable) => {
                                    return checkVariableType(
                                        variable.controlType,
                                        attributeType,
                                        dataSourceID,
                                        variable.attribute,
                                        variable.options,
                                        this._glob,
                                        runTimeWidgetID
                                    );
                                });

                                if (variable != null) {
                                    value = variable.values;
                                    intervals = variable.intervals;
                                } else {
                                    errorMessage = `A Local Filter with '${attributeName}' Attribute needs '${variableName}' Variable of ${explainAttributeType(
                                        attributeType
                                    )} type, but no Variable with such a name is compatible.`;
                                }
                            } else {
                                errorMessage = `A Local Filter with '${attributeName}' Attribute needs '${variableName}' Variable of ${explainAttributeType(
                                    attributeType
                                )} type, but it does not exist.`;
                            }

                            if (errorMessage != null) {
                                if (variableNamesAreEqual(variableName, VARIABLE_NULL)) {
                                    value = null;
                                    attributeType = ATTRIBUTE_TYPES.ANYTYPE;
                                } else {
                                    this._glob.AppActions.showNotification_Warning(
                                        errorMessage + ' The filter is ignored.',
                                        runTimeWidgetID
                                    );
                                    continue; // Drop the filter.
                                }
                            }
                        }

                        if (isValueEmpty(value)) {
                            if (this._glob.EntityModelsStore.isFunctionParameter(attributeName)) {
                                value = null;
                            } else {
                                continue; // Drop the filter.
                            }
                        }
                    }

                    if (valueType === 'exchangeObject') {
                        const exchangeObjectName = value as string;
                        const exchangeObject = this.getExchangeObject();
                        const foundRecords = exchangeObject.filter(
                            (obj) => obj.exchangeObjectName === exchangeObjectName
                        );
                        const idx = foundRecords.findIndex((obj) => obj.attribute === attributeName);

                        if (idx > -1) {
                            value = foundRecords[idx].values;
                        } else {
                            value = null;
                            continue; // Drop the filter.
                        }
                    }

                    const deepFiltering = options != null ? options.deepFiltering !== false : true;

                    newFilter = this.createAQLFilter(
                        attribute,
                        relation,
                        value,
                        dataSourceID,
                        attributeType,
                        runTimeWidgetID,
                        theme,
                        cultureValues,
                        intervals,
                        timeZone,
                        deepFiltering,
                        parentAttribute,
                        localFilter.label
                    );

                    if (newFilter == null) {
                        continue;
                    }
                }
            } else {
                const filterLeft = localFilter.left;
                const filterRight = localFilter.right;

                if (filterLeft != null && filterRight != null) {
                    if (filterLeft.length > 0 && filterRight.length > 0) {
                        const leftPart = this.makeLocalFilter(
                            filterLeft,
                            dataSourceID,
                            timeZone,
                            theme,
                            runTimeWidgetID,
                            cultureValues,
                            scopeOptions,
                            lookInNotAppliedFilters
                        );

                        if (leftPart == null) {
                            return null; // Cancel creation.
                        }

                        const rightPart = this.makeLocalFilter(
                            filterRight,
                            dataSourceID,
                            timeZone,
                            theme,
                            runTimeWidgetID,
                            cultureValues,
                            scopeOptions,
                            lookInNotAppliedFilters
                        );

                        if (rightPart == null) {
                            return null; // Cancel creation.
                        }

                        // Create filter if both OR Group parts exist. Otherwise, add a group with filters only.
                        if (leftPart.length > 0 && rightPart.length > 0) {
                            newFilter = GlobalState.createAQLFilterObject_OR(leftPart, rightPart);
                        } else if (rightPart.length > 0) {
                            rightPart.forEach((filter) => {
                                result.push(filter);
                            });

                            continue; // Filter(s) are added.
                        } else if (leftPart.length > 0) {
                            leftPart.forEach((filter) => {
                                result.push(filter);
                            });

                            continue; // Filter(s) are added.
                        }
                    } else {
                        this._glob.AppActions.showNotification_Fail(
                            'Filter with OR condition is wrong. The filter is ignored.',
                            runTimeWidgetID
                        );
                    }
                }
            }

            this.addAQLFilterToArray(newFilter, result);
        }

        return result;
    }

    private findGlobalFilterWithValue(globalFilters: IGlobalAttributeFilters, asfilter: IQueryFilter) {
        return _.find(globalFilters, (attributeFilter) => {
            if (sameAttributes(asfilter, attributeFilter)) {
                if (!isValueEmpty(attributeFilter.values)) {
                    return true;
                }
            }

            return false;
        });
    }

    private findExchangeObjectWithValue(localFilter: IQueryFilter[], asfilter: IQueryFilter): IExchangeObjectRecord {
        const exchangeObject = this.getExchangeObject();
        const filtersWithExcahgeObject = localFilter.filter(
            (filter) => filter.valueType === 'exchangeObject' && filter.attribute === asfilter.attribute
        );

        return _.find(exchangeObject, (obj) => {
            const idx = filtersWithExcahgeObject.findIndex((f) => f.value === obj.exchangeObjectName);

            if (idx !== -1 && !isValueEmpty(obj.values)) {
                return true;
            }

            return false;
        });
    }

    private static createAQLFilterObject_OR(left: IAQLFilter[], right: IAQLFilter[]): IAQLFilter {
        return {
            type: AQL.TYPE_OR,
            left,
            right
        };
    }

    private copyActualLocalFilters(
        localFilters: IAQLFilter[],
        filterToIgnore: IAQLFilter[],
        dataSourceID: number
    ): IAQLFilter[] {
        const result: IAQLFilter[] = [];

        if (localFilters == null || localFilters.length === 0) {
            return result;
        }

        _.each(localFilters, (filter: IAQLFilter) => {
            if (filter.type === AQL.TYPE_OR) {
                let resultForLeft = this.copyActualLocalFilters(filter.left, filterToIgnore, dataSourceID);
                let resultForRight = this.copyActualLocalFilters(filter.right, filterToIgnore, dataSourceID);

                if (resultForLeft.length > 0 && resultForRight.length > 0) {
                    // OR Filter is valid.
                    result.push(GlobalState.createAQLFilterObject_OR(resultForLeft, resultForRight));
                }
                // 02.10.2018: OR Filter must have both parts valid.
                // else if (resultForLeft.length > 0) {
                //     //OR Filter is invalid. Copy existing left part as AND.
                //     result = result.concat(resultForLeft);
                // }
                // else if (resultForRight.length > 0) {
                //     //OR Filter is invalid. Copy existing right part as AND.
                //     result = result.concat(resultForRight);
                // }
            } else if (filter.relation === RELATIONS.IGNORE) {
                filterToIgnore.push(filter);

                // See WI 99071.
                // Trees are filtered by Key Attribute, but are shown without it.
                // When entering an Attribute with Filter to Ignore as it is shown the ignoring does not work.
                // Solution: if an Entity to ignore has Key Attribute, ignore 'Entity + Key Attribute' too.
                const attribute = filter.attrib.join(ATTRIBUTE_SEPARATOR);
                const entity = this._glob.EntityModelsStore.getReferredEntity(attribute, dataSourceID);
                const keyAttribute = EntityModelsStore.getEntityKeyAttribute(entity);

                if (keyAttribute != null) {
                    const attributeWithKey = attribute + ATTRIBUTE_SEPARATOR + keyAttribute;

                    filterToIgnore.push({
                        attrib: attributeWithKey.split(ATTRIBUTE_SEPARATOR),
                        dataSourceID: dataSourceID,
                        relation: RELATIONS.IGNORE,
                        type: AQL.RELATION
                    });
                }
            } else {
                if (filter.relation !== RELATIONS.REQUIRE_VALUE) {
                    result.push(filter);
                }
            }
        });

        return result;
    }

    public mergeGlobalAndLocalFilters(
        globalFilter: IAQLFilter[],
        localFilter: IAQLFilter[],
        dataSourceID: number
    ): {
        aqlFilter: IAQLFilter[];
        actualLocalFilter: IAQLFilter[];
    } {
        let result: IAQLFilter[];
        let actualLocalFilter: IAQLFilter[];
        let filtersToIgnore: IAQLFilter[] = [];

        const localFilterIsSet = localFilter != null && localFilter.length > 0;

        if (localFilterIsSet) {
            actualLocalFilter = this.copyActualLocalFilters(localFilter, filtersToIgnore, dataSourceID);
            result = [...actualLocalFilter];
        } else {
            result = [];
        }

        if (globalFilter != null && globalFilter.length > 0) {
            for (let i = 0; i < globalFilter.length; i++) {
                const filter = globalFilter[i];

                if (filter.type !== AQL.TYPE_PERIOD) {
                    if (filter.dataSourceID === dataSourceID) {
                        if (filter.periodFilterControl == null && localFilterIsSet) {
                            let filterAttribute: string;

                            if (filter.attrib != null) {
                                filterAttribute = filter.attrib.join(ATTRIBUTE_SEPARATOR);
                            } else if (filter.syntaxTree != null) {
                                filterAttribute = JSON.stringify(filter.syntaxTree);
                            } else {
                                continue;
                            }

                            if (GlobalState.aqlAttributeFilterExists(filterAttribute, filtersToIgnore)) {
                                // Drop all global filters having 'attrib' as a local filter marked ignored.
                                continue;
                            }

                            if (
                                GlobalState.aqlAttributeFilterExists(filterAttribute, actualLocalFilter, {
                                    relation: filter.relation,
                                    type: filter.type,
                                    timePart: filter.timePart
                                })
                            ) {
                                // Drop all global filters having the same properties as a local filter.
                                continue;
                            }
                        }

                        result.push(filter);
                    }
                } else {
                    result.push(filter);
                }
            }
        }

        result = GlobalState.copyAndCleanFilter(result);

        if (actualLocalFilter != null) {
            actualLocalFilter = GlobalState.copyAndCleanFilter(actualLocalFilter);
        }

        return {
            aqlFilter: result,
            actualLocalFilter: actualLocalFilter
        };
    }

    private static copyAndCleanFilter(filters: IAQLFilter[]) {
        if (filters == null) {
            return;
        }

        return _.map(filters, (filter) => {
            const filterCopy = _.extend({}, filter) as IAQLFilter;
            delete filterCopy.dataSourceID;

            filterCopy.left = GlobalState.copyAndCleanFilter(filterCopy.left);
            filterCopy.right = GlobalState.copyAndCleanFilter(filterCopy.right);

            return filterCopy;
        });
    }

    private static aqlAttributeFilterExists(
        filterAttribute: string,
        existingFilters: IAQLFilter[],
        options?: {
            relation: string;
            type: string;
            timePart: string;
        }
    ) {
        if (existingFilters != null && existingFilters.length > 0) {
            for (let i = 0; i < existingFilters.length; i++) {
                const existingFilter = existingFilters[i];

                if (existingFilter.type === AQL.TYPE_PERIOD) {
                    continue;
                }

                let existingFilterAttribute: string;

                if (existingFilter.attrib != null) {
                    existingFilterAttribute = existingFilter.attrib.join(ATTRIBUTE_SEPARATOR);
                } else if (existingFilter.syntaxTree != null) {
                    existingFilterAttribute = JSON.stringify(existingFilter.syntaxTree);
                } else {
                    continue;
                }

                if (filterAttribute === existingFilterAttribute) {
                    // Attib is not defined for OR Conditions. Global Filter has no OR Conditions so they are not checked.
                    if (options != null) {
                        if (
                            options.relation === existingFilter.relation &&
                            options.type === existingFilter.type &&
                            options.timePart === existingFilter.timePart
                        ) {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    // Build filter by other Attributes. See Showing Valid+Invalid functionality.
    public buildFilterToGetValidValuesForAttribute(
        dataSourceID: number,
        currentFilter: IGlobalAttributeFilter,
        localFilter: IQueryFilter[],
        dataQueryData: IDataQueryData,
        showingType: AttributeValueShowingType,
        theme: IValuesCollection,
        cultureValues: ICultureValues,
        scopeOptions: IScopeOptions
    ): {
        aqlFilter: IAQLFilter[];
        actualLocalFilter: IAQLFilter[];
    } {
        const { globalFilterControl } = dataQueryData;
        const runTimeWidgetID =
            dataQueryData.getRunTimeWidgetID != null
                ? dataQueryData.getRunTimeWidgetID()
                : dataQueryData.runTimeWidgetID;
        const timeZone = DateTimeFunctions.getTimeZoneFromTheme(theme);

        let dataQueryAQLFilter: IAQLFilter[];
        let dataQueryFilters = dataQueryData.filters;

        if (dataQueryFilters != null && dataQueryFilters.length > 0) {
            if (dataQueryData.deepFiltering === false) {
                dataQueryFilters = [...dataQueryFilters];

                dataQueryFilters.forEach((filter) => {
                    if (filter.options == null) {
                        filter.options = {};
                    }

                    filter.options.deepFiltering = false;
                });
            }

            dataQueryAQLFilter = this.makeLocalFilter(
                dataQueryFilters,
                dataSourceID,
                timeZone,
                theme,
                runTimeWidgetID,
                cultureValues,
                null,
                true
            );
        }

        let globalAQLFilter: IAQLFilter[] = [];

        // When showingType is 'all' then no filter, but the ones from Data Query are applied.
        // Not specified showingType means 'all'.
        if (showingType != null && showingType !== 'all') {
            const periodFilter = this.getNotAppliedPeriodFilter(scopeOptions);

            this.makePeriodFilter(globalAQLFilter, scopeOptions, globalFilterControl, periodFilter);
            this.makeScopeFilters(globalAQLFilter, scopeOptions, globalFilterControl, dataSourceID, runTimeWidgetID);

            const globalFilterCollection = this.getNotAppliedAttributeFilterCollection();
            const data = this.getGlobalFilterAttributeData(
                dataSourceID,
                globalFilterControl,
                scopeOptions,
                runTimeWidgetID,
                globalFilterCollection
            );

            if (data.useGlobalFiltering) {
                const { globalFilters } = data;

                for (let attributeID in globalFilters) {
                    const filter = globalFilters[attributeID];

                    if (filter.valueType === 'variable' || filter.valueType === 'timePart') {
                        continue;
                    }

                    let aqlAttribute: string | IExpression;
                    let aqlAttributeName: string;

                    if (filter.expression != null) {
                        aqlAttribute = filter.expression;
                        aqlAttributeName = JSON.stringify(aqlAttribute);
                    } else {
                        aqlAttribute = aqlAttributeName = filter.attribute;
                    }

                    if (currentFilter != null) {
                        let currentFilterName: string;

                        if (currentFilter.expression != null) {
                            currentFilterName = JSON.stringify(currentFilter.expression);
                        } else {
                            currentFilterName = currentFilter.attribute;
                        }

                        if (aqlAttributeName === currentFilterName) {
                            continue;
                        }
                    }

                    const values = filter.values;

                    let attributeType = this.getDefaultAttributeType(filter, dataSourceID);

                    if (attributeType !== ATTRIBUTE_TYPES.LOGICAL && (values == null || values.length === 0)) {
                        continue;
                    }

                    const options = filter.options;

                    let parentAttribute: string;
                    let relation = options != null && options.relation ? options.relation : AQL.IN;
                    let deepGlobalFiltering = data.deepGlobalFiltering;

                    if (deepGlobalFiltering !== false && options != null) {
                        deepGlobalFiltering = options.deepFiltering;
                    }

                    if (filter.controlType === ATTRIBUTE_CONTROL_TYPES.TREE) {
                        const kp = getAttributesForTree(
                            aqlAttributeName,
                            options,
                            dataSourceID,
                            this._glob,
                            runTimeWidgetID
                        );

                        if (kp != null) {
                            aqlAttribute = aqlAttribute + ATTRIBUTE_SEPARATOR + kp.keyAttribute;
                            attributeType = this.getDefaultAttributeType(aqlAttribute, dataSourceID);
                            parentAttribute = kp.parentAttribute;
                        } else {
                            continue;
                        }

                        if (parentAttribute != null && this.optionIncludeSubnodesIsOn(options)) {
                            relation = RELATIONS.IS_SUBNODE_OF;
                            parentAttribute = filter.attribute + ATTRIBUTE_SEPARATOR + parentAttribute;
                        }
                    }

                    const aqlFilter = this.createAQLFilter(
                        aqlAttribute,
                        relation,
                        values,
                        dataSourceID,
                        attributeType,
                        runTimeWidgetID,
                        null,
                        cultureValues,
                        filter.intervals,
                        timeZone,
                        deepGlobalFiltering,
                        parentAttribute
                    );

                    if (aqlFilter != null) {
                        globalAQLFilter.push(aqlFilter);
                    }
                }
            }

            if (localFilter != null && localFilter.length > 0) {
                let localFilterCopy: IQueryFilter[];

                if (globalFilterControl != null && globalFilterControl.attributeFilter != null) {
                    const { attributesToAllow, attributesToIgnore, attributesToOverride } =
                        checkGlobalFilterControlAttributes(
                            globalFilterControl.attributeFilter,
                            dataSourceID,
                            runTimeWidgetID,
                            this._glob
                        );

                    if (attributesToAllow != null) {
                        localFilterCopy = [];

                        attributesToAllow.forEach((attributeName) => {
                            for (const filter of localFilter) {
                                if (sameAttributes(filter, attributeName)) {
                                    localFilterCopy.push(filter);
                                    break;
                                }
                            }
                        });
                    } else {
                        localFilterCopy = [...localFilter];
                    }

                    if (attributesToIgnore != null) {
                        attributesToIgnore.forEach((attributeName) => {
                            const indexToRemove = localFilterCopy.findIndex((filter) => {
                                return sameAttributes(filter, attributeName);
                            });

                            if (indexToRemove >= 0) {
                                localFilterCopy.splice(indexToRemove, 1);
                            }
                        });
                    }

                    if (attributesToOverride != null) {
                        attributesToOverride.forEach((item) => {
                            if (item.oldAttribute != null && item.newAttribute != null) {
                                localFilterCopy.forEach((filter, index) => {
                                    if (filter.attribute === item.oldAttribute) {
                                        filter = localFilterCopy[index] = { ...filter };
                                        filter.attribute = item.newAttribute;
                                    }
                                });
                            }
                        });
                    }
                } else {
                    localFilterCopy = [...localFilter];
                }

                const localAQLFilter = this.makeLocalFilter(
                    localFilterCopy,
                    dataSourceID,
                    timeZone,
                    theme,
                    runTimeWidgetID,
                    cultureValues,
                    null,
                    true
                );

                if (localAQLFilter != null && localAQLFilter.length > 0) {
                    globalAQLFilter = globalAQLFilter.concat(localAQLFilter);
                }
            }
        }

        // Merge is needed in order to drop local filters marked with 'ignore'.
        return this.mergeGlobalAndLocalFilters(globalAQLFilter, dataQueryAQLFilter, dataSourceID);
    }

    public expressionBindVariables(
        expression: IExpression,
        dataSourceID: number,
        runTimeWidgetID: number,
        scopeOptions: IScopeOptions,
        cultureValues?: ICultureValues,
        globalFilterCollection?: IGlobalAttributeFilterCollection,
        requreValue?: boolean,
        messageForRequreValue?: string
    ): IExpression {
        const result = $.extend(true, {}, expression);
        const allVariables = this.getAllVariables(dataSourceID, cultureValues, scopeOptions, globalFilterCollection);
        const text = result.text;

        delete result.text; // 'text' is not to be sent to backend.

        let errorString: string;

        JsonTraverse.traverse(result.syntaxTree, (el) => {
            if (el != null && el.hasOwnProperty('var')) {
                const variableName = el['var'].replace(/'/g, '');
                const variable = findFirstVariable(allVariables, variableName, false);

                if (variable != null) {
                    let values = variable.values;

                    if (Array.isArray(values)) {
                        if (values.length === 0) {
                            values = null;
                        } else if (variable.selectionType !== 'multiply') {
                            values = [values[0]];
                        }
                    }

                    if (values != null) {
                        const { timeZone } = variable;
                        const variableType = getVariableType(
                            variable.controlType,
                            variable.attribute,
                            variable.options,
                            dataSourceID,
                            this._glob,
                            runTimeWidgetID
                        );

                        if (Array.isArray(values)) {
                            el['var'] = values.map((value) => {
                                return this.formatValueByType_WithMessage(
                                    value,
                                    variableType,
                                    runTimeWidgetID,
                                    null,
                                    timeZone
                                );
                            });
                        } else {
                            el['var'] = this.formatValueByType_WithMessage(
                                values,
                                variableType,
                                runTimeWidgetID,
                                null,
                                timeZone
                            );
                        }
                    } else if (requreValue) {
                        if (messageForRequreValue != null && messageForRequreValue.length > 0) {
                            errorString = messageForRequreValue;
                        } else {
                            errorString = `Value for Variable '${variableName}' must be specified for Expression '${text}'.`;
                        }
                    } else {
                        el['var'] = null;
                    }
                } else if (variableNamesAreEqual(variableName, VARIABLE_NULL)) {
                    el['var'] = null;
                } else {
                    errorString = `Variable '${variableName}' is not found in Global State. Expression '${text}' is ignored.`;
                }
            }
        });

        if (errorString != null) {
            this._glob.AppActions.showNotification_Warning(errorString, runTimeWidgetID);
            return null;
        }

        return result;
    }

    // public static createStateFromURLParameters(params: IURLQuery) {
    //     const keys = _.keys(params);
    //     const attributeFilterCollection: IGlobalAttributeFilterCollection = {};
    //     const periodFilter: IAQLFilter = {};

    //     let i = 0;

    //     while (i < keys.length) {
    //         const attributeFilters: IGlobalAttributeFilters = {};
    //         const key = keys[i];

    //         let dataSourceID = '0';

    //         if (key === URL_KEYS.PeriodStart || key === URL_KEYS.PeriodFrom) {
    //             periodFilter.from = params[key].val[0];
    //             i++;
    //             continue;
    //         }

    //         if (key === URL_KEYS.PeriodEnd || key === URL_KEYS.PeriodTo) {
    //             periodFilter.to = params[key].val[0];
    //             i++;
    //             continue;
    //         }

    //         if (key === URL_KEYS.Month) {
    //             periodFilter.month = _.map(params[key].val, (n: string) => {
    //                 return parseInt(n);
    //             });
    //             i++;
    //             continue;
    //         }

    //         if (key === URL_KEYS.Quarter) {
    //             periodFilter.quarter = _.map(params[key].val, (n: string) => {
    //                 return parseInt(n);
    //             });
    //             i++;
    //             continue;
    //         }

    //         if (key === URL_KEYS.Year) {
    //             periodFilter.year = _.map(params[key].val, (n: string) => {
    //                 return parseInt(n);
    //             });
    //             i++;
    //             continue;
    //         }

    //         if (key.indexOf(URL_KEYS.Datasource) === 0) {
    //             dataSourceID = params[key].val[0];
    //             i++;

    //             while (i < keys.length && keys[i].indexOf(URL_KEYS.Datasource) === -1) {
    //                 let dsKey = keys[i];
    //                 const param = params[dsKey];

    //                 if (dsKey === URL_KEYS.PeriodStart || dsKey === URL_KEYS.PeriodFrom) {
    //                     periodFilter.from = param.val[0];
    //                     i++;
    //                     continue;
    //                 }

    //                 if (dsKey === URL_KEYS.PeriodEnd || dsKey === URL_KEYS.PeriodTo) {
    //                     periodFilter.to = param.val[0];
    //                     i++;
    //                     continue;
    //                 }

    //                 if (dsKey === URL_KEYS.Month) {
    //                     periodFilter.month = _.map(param.val, (n: string) => {
    //                         return parseInt(n);
    //                     });
    //                     i++;
    //                     continue;
    //                 }

    //                 if (dsKey === URL_KEYS.Quarter) {
    //                     periodFilter.quarter = _.map(param.val, (n: string) => {
    //                         return parseInt(n);
    //                     });
    //                     i++;
    //                     continue;
    //                 }

    //                 if (dsKey === URL_KEYS.Year) {
    //                     periodFilter.year = _.map(param.val, (n: string) => {
    //                         return parseInt(n);
    //                     });
    //                     i++;
    //                     continue;
    //                 }

    //                 if (dsKey.indexOf('@') === 0) {
    //                     dsKey = '@' + dsKey;
    //                 }

    //                 let options = null;

    //                 switch (param.op) {
    //                     case 'eq':
    //                         if (param.val.length > 1) {
    //                             options = {
    //                                 relation: RELATIONS.IS_ONE_OF
    //                             };
    //                         }
    //                         break;
    //                     case 'ne':
    //                         if (param.val.length > 1) {
    //                             options = {
    //                                 relation: RELATIONS.IS_NOT_ONE_OF
    //                             };
    //                         } else {
    //                             options = {
    //                                 relation: RELATIONS.NOT_EQUAL
    //                             };
    //                         }
    //                         break;
    //                     case 'le':
    //                         options = {
    //                             relation: RELATIONS.LESS_OR_EQUAL
    //                         };
    //                         break;
    //                     case 'ge':
    //                         options = {
    //                             relation: RELATIONS.MORE_OR_EQUAL
    //                         };
    //                         break;
    //                     case 'lt':
    //                         options = {
    //                             relation: RELATIONS.LESS
    //                         };
    //                         break;
    //                     case 'gt':
    //                         options = {
    //                             relation: RELATIONS.MORE
    //                         };
    //                         break;
    //                 }

    //                 if (param.val[0] === 'true') {
    //                     param.val[0] = true;
    //                 }

    //                 if (param.val[0] === 'false') {
    //                     param.val[0] = false;
    //                 }

    //                 const { attributeName, isVariable, isTimePart, attributeVariable } = parseURLAttribute(
    //                     dsKey,
    //                     param
    //                 );
    //                 const attributeID = createAttributeID(attributeName, dataSourceID, attributeFilters); //attributeName.attribute;
    //                 const attributeFilter: IGlobalAttributeFilter = {
    //                     //attribute: param.attr,
    //                     ...attributeName,
    //                     values: param.val,
    //                     id: attributeID //dsKey
    //                 };

    //                 if (isVariable) {
    //                     attributeFilter.valueType = 'variable';
    //                 } else if (isTimePart) {
    //                     //attributeFilter.attribute = attributeID;
    //                     //attributeFilter.id = attributeID;
    //                     attributeFilter.valueType = 'timePart';
    //                 }

    //                 if (options != null) {
    //                     attributeFilter.options = options;
    //                 }

    //                 if (attributeVariable != null) {
    //                     if (attributeFilter.options == null) {
    //                         attributeFilter.options = {};
    //                     }

    //                     attributeFilter.options.variableName = attributeVariable;
    //                 }

    //                 attributeFilters[attributeID] = attributeFilter;
    //                 i++;
    //             }

    //             attributeFilterCollection[dataSourceID] = attributeFilters;
    //         } else {
    //             i++;
    //         }
    //     }

    //     const result: IGlobalStateFilters = {};

    //     result.attributeFilters = attributeFilterCollection;

    //     if (!_.isEmpty(periodFilter)) {
    //         periodFilter.type = AQL.TYPE_PERIOD;
    //         result.periodFilters = [periodFilter];
    //     }

    //     return {
    //         'business-intelligence': result
    //     };
    // }
}
